{
  "account": {
    "circularGradient": "圆形渐变",
    "marketBreakdown": {
      "tables": {
        "borrowTableTitle": "已借入",
        "eModeHeader": {
          "illustrationAltText": "E-mode插图",
          "title": "E-mode：<UnderlinedText>{{eModeGroupName}}</UnderlinedText>"
        },
        "isolatedModeHeader": {
          "title": "隔离模式：<UnderlinedText>{{groupName}}</UnderlinedText>"
        },
        "supplyTableTitle": "已存款",
        "tabletBorrowTabTitle": "已借入",
        "tabletSupplyTabTitle": "已存款",
        "tabletTitle": "资产"
      }
    },
    "performanceChart": {
      "absolutePerformance": "绝对表现",
      "dataPoint": {
        "date": "{{ date, textual }}"
      },
      "errorState": {
        "failedToFetchMessage": "无法获取账户历史",
        "refetchButtonLabel": "重试"
      },
      "netWorth": {
        "label": "净值",
        "tooltip": "在考虑金库供应和借贷后可用的净资产",
        "tooltipWithVai": "在考虑金库供应、借贷和已铸造 VAI 后可用的净资产"
      },
      "periodOption": {
        "oneYear": "1年",
        "sixMonths": "6个月",
        "thirtyDays": "30天"
      },
      "placeholderText": "正在生成报告，最多可能需要一分钟",
      "todaysChange": "今日变化",
      "xAxisValue": "{{ date, numeric }}"
    },
    "placeholder": {
      "buttonLabel": "浏览"
    },
    "pools": {
      "placeholder": {
        "title": "尚无存款或借入持仓"
      }
    },
    "settings": {
      "gaslessTransactions": {
        "switchLabel": "在 {{chainName}} 上启用免 gas 交易"
      }
    },
    "summary": {
      "cellGroup": {
        "dailyEarnings": "每日收益",
        "healthFactor": "健康系数",
        "healthFactorTooltip": "清算阈值 < 1.0",
        "mintedVai": "已铸造 VAI",
        "netApy": "净 APY",
        "netApyTooltip": "以年化利息形式获得的总存款余额百分比",
        "netApyWithVaultStakeTooltip": "以年化利息形式获得的总供应余额和金库供应百分比",
        "totalBorrow": "总借款",
        "totalSupply": "总存款",
        "totalVaultStake": "总金库供应"
      },
      "title": "概览"
    },
    "tabs": {
      "markets": "市场",
      "settings": "设置",
      "transactions": "交易",
      "vaults": "金库"
    },
    "transactions": {
      "date": {
        "full": "{{ date, textual }}",
        "time": "{{ date, time }}"
      },
      "placeholder": {
        "description": "你的交易将显示在此",
        "title": "尚无交易"
      },
      "selects": {
        "source": {
          "all": "所有市场"
        },
        "txType": {
          "all": "所有交易"
        }
      },
      "today": "今天",
      "txText": {
        "enterMarket": "<Styled>启用</Styled> {{vTokenSymbol}} 作为可抵押",
        "exitMarket": "<Styled>禁用</Styled> {{vTokenSymbol}} 作为可抵押"
      },
      "txType": {
        "borrow": "借款",
        "enterMarket": "启用抵押",
        "exitMarket": "禁用抵押",
        "mint": "存款",
        "positionClosedWithLoss": "平仓（亏损） • Trade",
        "positionClosedWithProfit": "平仓（盈利） • Trade",
        "positionIncreased": "增加 • Trade",
        "positionOpened": "开仓 • Trade",
        "positionReducedWithLoss": "减少（亏损） • Trade",
        "positionReducedWithProfit": "减少（盈利） • Trade",
        "principalSupplied": "存款 • Trade",
        "principalWithdrawn": "取款 • Trade",
        "realizedPnl": "已实现盈亏 • Trade",
        "redeem": "取款",
        "repay": "还款"
      },
      "yesterday": "昨天"
    },
    "vaults": {
      "placeholder": {
        "title": "尚无供应持仓"
      }
    }
  },
  "accountData": {
    "balanceUpdate": {
      "borrowBalance": "借款余额",
      "supplyBalance": "存款余额"
    },
    "dailyEarnings": {
      "label": "每日收益"
    },
    "healthFactor": {
      "label": "健康系数",
      "tooltip": "清算阈值 < 1.0"
    }
  },
  "accountHealth": {
    "accessibilityLabel": "当前账户状态的表示",
    "borrowed": "已借：",
    "borrowedSpotTooltip": "此借款价值基于借入资产的现货价格计算，将用于确定您账户的健康状态。",
    "liquidationThreshold": "清算阈值：",
    "liquidationThresholdShort": "LT:",
    "liquidationThresholdTooltip": "LT = 清算阈值<LineBreak/>当您的借款余额达到此值时，您的仓位将有资格被清算。<LineBreak/><LineBreak/>了解更多关于<Link>计算方式。</Link>",
    "tooltip": "借款余额：<LineBreak/>{{borrowBalance}}（借款限额的{{borrowLimitUsedPercentage}}）<LineBreak/><LineBreak/>借款限额：<LineBreak/>{{borrowLimit}}",
    "tooltipProtection": "借款余额（保护）：<LineBreak/>{{borrowBalanceProtected}}（借款限额的{{protectedBorrowLimitUsedPercentage}}）<LineBreak/><LineBreak/>借款余额（现货）：{{borrowBalance}}<LineBreak/>借款限额：{{borrowLimitProtected}}"
  },
  "adBanner": {
    "startNow": "立即开始"
  },
  "announcements": {
    "bethUpdate": {
      "description": "Binance 于 2023-04-26 暂停了 BETH 提现。我们建议用户减少在 Venus 上的 BETH 曝险。借款已暂停。可在链上按 1:1 比例将 BETH 转换为 WBETH，<Link>点击此处</Link>。"
    },
    "sxpDisabling": {
      "description": "根据 Gauntlet 的建议，由于 SXP 迁移到新链以及预计 SXP 流动性下降的担忧，SXP 的借款和存款已暂停。"
    },
    "trxMigration": {
      "description": "Venus 在新市场支持新的 TRX 代币。旧 TRX 代币的借款与存款已暂停。更多信息请见 <Link>Binance 官方公告</Link>。"
    },
    "tusdMigration": {
      "description": "Venus 在新市场支持新的 TUSD 代币。旧 TUSD 代币的借款与存款已暂停。更多信息请见 <Link>Binance 官方公告</Link>。"
    }
  },
  "approveDelegateSteps": {
    "approveDelegateButton": {
      "text": "授权委托合约",
      "tooltip": "我们需要授权委托合约以代表你执行此操作。"
    },
    "step1": "步骤 1"
  },
  "approveTokenSteps": {
    "approveTokenButton": {
      "text": "授权 {{tokenSymbol}}",
      "tooltip": "使用 Venus 协议的任何代币都需要支出授权。"
    },
    "step1": "步骤 1",
    "step2": "步骤 2"
  },
  "appVersionChecker": {
    "newVersionMessage": "Venus 有新版本可用。请刷新页面以立即使用。"
  },
  "apy": {
    "boost": {
      "iconAlt": "Boost 市场图标",
      "tooltip": {
        "borrowApy": {
          "description": "在 Venus 协议中借入该资产时产生的利息。",
          "name": "借款 APY"
        },
        "defaultMerklRewardName": "Merkl 奖励",
        "externalRewardDescription": "该外部计划的奖励可通过其 <AppLink>官方应用</AppLink>领取。Venus 协议不作任何保证且不承担责任。",
        "intrinsicApy": {
          "description": "标的资产本身产生的原生收益——例如存款奖励。该收益来自外部来源，不由 Venus 协议保证。",
          "name": "内在 APY"
        },
        "offChainApy": {
          "description": "来自空投或推广活动等第三方管理的链下活动的额外收益。该收益不由 Venus 协议保证。",
          "name": "链下 APY"
        },
        "pointDistribution": {
          "learnMore": "了解更多"
        },
        "primeDistribution": {
          "description": "Venus Prime 为忠实用户提供加成奖励。Venus 协议不作任何保证且不承担责任。",
          "name": "Prime APY"
        },
        "supplyApy": {
          "description": "向 Venus 协议提供资产所获得的总收益。",
          "name": "存款 APY"
        },
        "xvsDistribution": {
          "description": "分发奖励由去中心化的 Venus 社区发起并实施。Venus 协议不作任何保证且不承担责任。",
          "name": "XVS 分发"
        },
        "yieldToMaturityApy": {
          "description": "该收益表示使用标的资产折价购买 PT 代币并持有至到期所获得的年化回报。Venus 协议不作任何保证且不承担责任。",
          "name": "到期收益率 APY"
        }
      }
    },
    "primeBadge": {
      "logoAlt": "Prime 标志",
      "tooltip": {
        "calculatorLink": "计算你的 Prime 奖励",
        "primeBorrowSimulation": "Prime 加成基于用户借款中位数 {{borrowBalance}} 与金库存入 {{xvsStaked}} 提升 APY。",
        "primeDocLink": "了解更多",
        "primeMarket": "Prime 提升 APY。",
        "primeSupplySimulation": "Prime 加成基于用户存款中位数 {{supplyBalance}} 与金库存入 {{xvsStaked}} 提升 APY。"
      }
    }
  },
  "apyBreakdown": {
    "borrowApy": "借款 APY",
    "distributionApy": "分发 APY",
    "distributionTooltip": "分发奖励由去中心化的 Venus 社区发起并实施。Venus 协议不作任何保证且不承担责任。",
    "externalDistributionApy": "{{description}} APY",
    "intrinsicApy": "内在 APY",
    "intrinsicApyTooltip": "直接来自资产本身的 APY（如存款或外部奖励），与 Venus 借贷收益分开。Venus 协议不作任何保证且不承担责任。",
    "netApy": {
      "label": "净 APY",
      "tooltip": "涉及的所有市场 APY 之和"
    },
    "offChainApy": "链下 APY",
    "offChainApyTooltip": "来自空投或推广活动等第三方管理的链下活动的额外收益。Venus 协议不作任何保证且不承担责任。",
    "primeApy": "Prime APY",
    "supplyApy": "存款 APY",
    "totalApy": {
      "borrowApyLabel": "总借款 APY",
      "borrowApyTooltip": "借款 APY - 分发 APY",
      "supplyApyLabel": "总存款 APY",
      "supplyApyTooltip": "存款 APY + 分发 APY"
    },
    "yieldToMaturityApy": "到期收益率 APY",
    "yieldToMaturityApyTooltip": "该收益表示使用标的资产折价购买 PT 代币并持有至到期的年化回报。Venus 协议不作任何保证且不承担责任。"
  },
  "apyChart": {
    "date": {
      "full": "{{ date, numeric }}",
      "short": "{{ date, numericWithTime }}"
    },
    "tooltipItemLabels": {
      "borrowApy": "借款 APY",
      "date": "日期",
      "supplyApy": "存款 APY",
      "totalBorrow": "总借款",
      "totalStaked": "总供应量",
      "totalSupply": "总存款"
    }
  },
  "asset": {
    "marketInfo": {
      "title": "市场信息"
    }
  },
  "assetAccessor": {
    "assetNotAvailable": "此资产在您所在的国家/地区不可用",
    "disabledActionNotice": {
      "boost": "该市场已禁用 Boost",
      "borrow": "该市场已禁用借款",
      "repay": "该市场已禁用还款",
      "supply": "该市场已禁用存款",
      "withdraw": "该市场已禁用取款"
    },
    "eModeBlockedActionNotice": {
      "borrow": "你的 E-mode设置不允许从该市场借款。<Link>管理 E-mode</Link>"
    },
    "isolationModeBlockedActionNotice": {
      "borrow": "你的隔离模式设置不允许从该市场借款。<Link>管理 E-mode</Link>"
    }
  },
  "assetWarning": {
    "modalTitle": "{{ poolName }} 代币",
    "modeInfoHint": "<LineBreak/>访问<ModeInfoButton>模式信息</ModeInfoButton>区域以查看更多可用的组。",
    "modeOnly": {
      "eMode": "{{tokenSymbol}} 仅在 E-mode 中可用。访问<ModeInfoButton>模式信息</ModeInfoButton>区域以启用该组，或浏览<ShowAllMarketsButton>其他资产</ShowAllMarketsButton>。",
      "eModeAndIsolation": "{{tokenSymbol}} 仅在 E-mode 和隔离模式中可用。访问<ModeInfoButton>模式信息</ModeInfoButton>区域以启用其中一个组，或浏览<ShowAllMarketsButton>其他资产</ShowAllMarketsButton>。",
      "isolation": "{{tokenSymbol}} 仅在隔离模式中可用。访问<ModeInfoButton>模式信息</ModeInfoButton>区域以启用该组，或浏览<ShowAllMarketsButton>其他资产</ShowAllMarketsButton>。"
    },
    "supplyDescription": "向核心池提供 {{tokenSymbol}} 将使你只能从该池借入代币。<ShowAllMarketsButton>显示全部市场</ShowAllMarketsButton>"
  },
  "availableBalance": {
    "label": "可用"
  },
  "boostBanner": {
    "description": "一键杠杆提升收益 <White>最高 5 倍</White>。",
    "rocketAltText": "火箭插图",
    "title": "Boost 已上线！"
  },
  "breadcrumbs": {
    "bridge": "跨链桥",
    "dashboard": "仪表盘",
    "governance": "治理",
    "isolatedPools": "隔离池",
    "leaderboard": "排行榜",
    "markets": "市场",
    "primeCalculator": "Prime 计算器",
    "proposal": "提案 #{{proposalId}}",
    "swap": "兑换",
    "vai": "VAI",
    "vaults": "金库"
  },
  "bridgePage": {
    "amountInput": {
      "label": "数量",
      "maxButtonLabel": "最大"
    },
    "bridgeGasFee": {
      "label": "跨链桥 gas 费",
      "tooltip": "用于覆盖将转账发送到目标链的 gas 成本"
    },
    "errors": {
      "dailyTransactionLimitExceeded": {
        "message": "由于 24 小时限制，你无法在目标链上桥接超过 {{readableAmountTokens}}（{{readableAmountUsd}}）。该限制将在 {{ date, textualWithTime }} 重置",
        "submitButton": "输入金额超过每日限额"
      },
      "doesNotHaveEnoughNativeFunds": "{{tokenSymbol}} 余额不足",
      "doesNotHaveEnoughXvs": "{{tokenSymbol}} 余额不足",
      "mintCapReached": {
        "message": "由于跨链桥铸造上限，你无法桥接超过 {{readableAmountTokens}}",
        "submitButton": "跨链桥铸造上限已达"
      },
      "singleTransactionLimitExceeded": {
        "message": "你无法在目标链上单笔桥接超过 {{readableAmountTokens}}（{{readableAmountUsd}}）",
        "submitButton": "输入金额超过上限"
      }
    },
    "footer": {
      "bridgeDocLink": "如何跨链",
      "poweredBy": "技术支持"
    },
    "fromChainSelect": {
      "label": "从"
    },
    "submitButton": {
      "label": {
        "enterValidAmount": "输入有效金额",
        "submit": "确认"
      }
    },
    "toChainSelect": {
      "label": "到"
    },
    "walletBalance": {
      "label": "钱包余额"
    }
  },
  "chainExplorerLink": {
    "content": "在 {{domainName}} 上查看"
  },
  "chip": {
    "proposalType": {
      "critical": "关键",
      "fastTrack": "快速通道"
    }
  },
  "claimReward": {
    "modal": {
      "claimButton": {
        "disabledLabel": "选择要领取奖励的组",
        "enabledLabel": "领取"
      },
      "claimOn": "在 {{appName}} 上领取",
      "externalRewards": "外部奖励",
      "primeGroup": {
        "disabledContractWarningMessage": "Prime 合约目前已暂停。Prime 的利息仍在累积，但需等合约恢复后才能领取。",
        "name": "Prime"
      },
      "rewards": "奖励",
      "title": "领取奖励（{{chainName}}）",
      "vaultGroup": {
        "disabledContractWarningMessage": "该金库当前已暂停。利率仍在累积，但在金库恢复前无法领取。",
        "name": "{{stakedTokenSymbol}} 金库"
      },
      "vestingVaultGroup": {
        "name": "{{stakedTokenSymbol}} 归属金库"
      }
    }
  },
  "connectButton": {
    "connect": "连接钱包",
    "disconnect": "断开连接"
  },
  "connectWallet": {
    "connectButton": "连接钱包"
  },
  "contractErrors": {
    "actionPaused": "该市场暂时禁用此操作。",
    "borrowCapExceeded": "该市场已达到借款上限。",
    "insufficientCollateral": "抵押品不足以完成此操作。",
    "insufficientLiquidity": "可用流动性不足以完成此操作。",
    "notice": {
      "copyDetails": "复制详情",
      "errorLabel": "错误",
      "fallback": "交易将失败，请检查输入后重试。",
      "hideRawError": "隐藏原始错误",
      "showRawError": "显示原始错误"
    },
    "supplyCapExceeded": "该市场已达到存款上限。",
    "swapDeadlineExpire": "兑换已超时，请重试。",
    "tooMuchRepay": "还款金额超过了你的未偿借款。"
  },
  "controls": {
    "pausedAssetsToggle": {
      "label": "已暂停资产"
    },
    "userAssetsOnlyToggle": {
      "label": "仅我的资产"
    }
  },
  "dashboard": {
    "guide": {
      "completed": "已完成",
      "step1": {
        "description": "通过存款或将现有持仓迁移到 Venus 协议来赚取收益。",
        "title": "存款 / 迁移"
      },
      "step2": {
        "description": "活用借贷来应用你的Defi策略，或使用一键杠杆来放大持仓。",
        "title": "借款 / 杠杆"
      },
      "step3": {
        "description": "将 XVS 供应至金库，赚取由协议收入提供的收益。",
        "title": "供应 XVS"
      },
      "uncompleted": "未完成"
    },
    "overview": {
      "absolutePerformance": "绝对表现",
      "netWorth": {
        "label": "净值",
        "tooltip": "在计入金库供应和借款后可用的净资产",
        "tooltipWithVai": "在计入金库供应、借款和已铸 VAI 后可用的净资产"
      },
      "performanceChart": {
        "errorState": {
          "failedToFetchMessage": "无法获取账户历史记录",
          "refetchButtonLabel": "重试"
        },
        "placeholderText": "正在生成报告，最多可能需要一分钟"
      },
      "periodOption": {
        "oneYear": "1年",
        "sixMonths": "6个月",
        "thirtyDays": "30天"
      },
      "summary": {
        "cellGroup": {
          "dailyEarnings": "每日收益",
          "mintedVai": "已铸 VAI",
          "netApy": "净 APY",
          "netApyTooltip": "您总存款余额与金库存入按年利息获得的百分比",
          "netApyWithVaultStakeTooltip": "您总供应余额与金库供应按年利息获得的百分比",
          "totalBorrow": "总借款",
          "totalSupply": "总存款",
          "totalVaultStake": "金库供应总额"
        },
        "title": "摘要"
      },
      "todaysChange": "今日变化"
    },
    "performanceChart": {
      "dataPoint": {
        "date": "{{ date, textual }}"
      },
      "xAxisValue": "{{ date, numeric }}"
    },
    "topMarkets": {
      "borrowButton": {
        "label": "借款"
      },
      "interactiveTitle": "焦点 ( <Group><SupplyButton>存款</SupplyButton>/<BorrowButton>借款</BorrowButton></Group> )",
      "supplyButton": {
        "label": "存款"
      },
      "textTitle": "焦点"
    },
    "vaults": {
      "dailyEarnings": "每日收益",
      "dailyEarningsTooltip": "您在所有活跃金库中的每日预计收益，基于各金库的当前利率或固定 APR。实际收益可能有所变化。",
      "totalStakedValue": "总供应价值"
    }
  },
  "eModeBanner": {
    "exploreButtonLabel": "探索",
    "illustrationAltText": "E-mode插图",
    "manageEModeButtonLabel": "管理 E-mode",
    "title": "使用 E-mode 提升借款能力"
  },
  "eModeGroupList": {
    "controls": {
      "mobileSelectLabel": "排序：",
      "searchPlaceholder": "搜索组或资产"
    },
    "group": {
      "cannotDisable": {
        "tooltip": {
          "blockingPositions": "你无法禁用该组，因为你有包含无法从该池借款的资产的借款仓位。<Link>显示我的仓位</Link>",
          "notEnoughCollateral": "你无法禁用该组，因为你的总可抵押价值不足以覆盖总借款余额"
        }
      },
      "cannotEnable": {
        "modal": {
          "description": "要启用 <WhiteText>{{ eModeGroupName }}</WhiteText> 组，你需要关闭以下借款仓位：",
          "repayButtonLabel": "还款",
          "title": "你的仓位"
        },
        "tooltip": {
          "blockingPositions": "你无法启用该组，因为你有不属于该组的资产借款仓位。<Link>显示我的仓位</Link>",
          "notEnoughCollateral": "你无法启用该组，因为你的总可抵押价值不足以覆盖总借款余额"
        }
      },
      "disableButtonLabel": "禁用",
      "disabledNotice": "该组已不再支持。你的账户将回到核心池参数。请切换到其他可用组或将其禁用。",
      "enableButtonLabel": "启用",
      "healthFactor": "健康系数：",
      "switchButtonLabel": "切换"
    },
    "table": {
      "columns": {
        "asset": "资产",
        "collateral": "可抵押",
        "isBorrowable": "可借",
        "liquidationPenalty": "清算罚金",
        "liquidationThreshold": "清算阈值",
        "maxLtv": "最大 LTV"
      }
    }
  },
  "errors": {
    "couldNotRetrieveSigner": "无法获取签名者，请确保钱包已解锁并刷新页面",
    "couldNotSwitchChain": "无法切换链，请确保钱包已解锁并刷新页面",
    "missingAbstainDescription": "提案需要“弃权”票描述",
    "missingAgainstDescription": "提案需要“反对”票描述",
    "missingDescription": "文件中没有提案描述",
    "missingForDescription": "提案需要“赞成”票描述",
    "missingParamForSignature": "函数缺少对应参数",
    "missingSafeWalletApiUrl": "由于配置错误无法获取 Safe 交易",
    "missingTargetForSignature": "函数缺少对应目标",
    "missingTitle": "提案需要标题",
    "noMetaKey": "文件中没有元数据信息",
    "noParamsKey": "文件中没有参数列表",
    "noSignaturesKey": "文件中没有调用签名",
    "noSwapQuoteFound": "未找到兑换。",
    "noTargetsKey": "文件中没有目标列表",
    "noTypeKey": "文件中未指明提案类型",
    "proposalNotFound": "未找到提案",
    "somethingWentWrong": "出了点问题",
    "somethingWentWrongRetrievingTransactions": "获取交易时出错",
    "somethingWentWrongRetrievingVoterAccounts": "获取投票账户时出错",
    "somethingWentWrongRetrievingVoterDetails": "获取投票者详情时出错",
    "somethingWentWrongRetrievingVoterHistory": "获取投票历史时出错",
    "undefinedAccountErrorMessage": "账户未定义",
    "validationError": "导入的提案验证失败：",
    "walletNotConnected": "钱包未连接"
  },
  "errorState": {
    "defaultMessage": "发生错误"
  },
  "footer": {
    "links": {
      "documentation": "文档",
      "privacyPolicy": "隐私政策",
      "skills": "智能体技能",
      "termsOfUse": "使用条款"
    }
  },
  "gaslessTransactions": {
    "chainLabel": "免费",
    "errorModal": {
      "cancel": "取消",
      "description": "你仍可自行支付 gas 发送此交易",
      "resendButtonLabel": "使用 gas 重新发送",
      "title": "目前无法使用免 gas 交易"
    },
    "tooltip": {
      "disabled": "该网络支持免 gas 交易且无需费用，但此功能目前在设置中被禁用。更多信息 <Link>这里</Link>",
      "enabled": "该网络上的交易免 gas 且无需费用。更多信息 <Link>这里</Link>"
    }
  },
  "gatedAssetAcknowledgementModal": {
    "acceptButtonLabel": "我理解并确认",
    "description": "bStocks 是由 BTECH Holdings Ltd (ADGM) 发行的代币化证券。此处展示的信息仅供参考，不构成任何要约、招揽或投资建议。bStocks 不面向美国、任何美国人士或任何其他受限制司法管辖区进行分发。投资存在风险，您的投资价值可能下跌，且您可能无法收回全部投资金额。有关完整的风险披露、法律文件以及受限制司法管辖区名单，请访问 <Link>bstocks.finance/prospectus</Link>。<LineBreak/><LineBreak/>继续操作即表示您确认自己不是受限制人士，并且在您所在的司法管辖区访问此产品是合法的。",
    "rejectButtonLabel": "我拒绝并离开",
    "title": "重要提示"
  },
  "healthFactor": {
    "label": {
      "healthy": "健康",
      "liquidation": "清算",
      "moderate": "中等",
      "risky": "风险"
    }
  },
  "importPositionsModal": {
    "aave": {
      "logoAlt": "Aave 标志",
      "title": "Aave"
    },
    "emptyState": "没有可导入的外部仓位",
    "gasLess": {
      "label": "免费",
      "tooltip": "迁移仓位到 Venus 的交易由 Venus 协议赞助"
    },
    "infoSection": {
      "1": {
        "description": "唯一提供真实收益提升 APY 的平台。",
        "title": "更高收益"
      },
      "2": {
        "description": "加入最具价值创造力且持续增长的 DeFi 平台。",
        "title": "最高资本效率"
      },
      "3": {
        "description": "久经考验且为借贷领域审计最多的合约。",
        "title": "顶级安全"
      },
      "title": "为什么选择 Venus？"
    },
    "limitNotice": "目前仅可导入价值介于 <Number>{{min}}</Number> 和 <Number>{{max}}</Number> 的仓位到 Venus。",
    "position": {
      "currentApy": {
        "label": "当前 APY"
      },
      "importButtonLabel": "导入",
      "missedYearlyGains": "你错过了 <Number><Gains /> / 年</Number>",
      "newApy": {
        "label": "Venus APY"
      }
    },
    "title": "导入到 Venus 并赚取更多"
  },
  "interactive": {
    "addToWallet": {
      "modalTitle": "添加代币到钱包"
    },
    "copy": {
      "address": {
        "modalTitle": "复制代币地址",
        "name": "地址",
        "tooltip": "复制地址"
      }
    },
    "copyToClipboard": "{{name}} 已复制到剪贴板",
    "goTo": {
      "modalTitle": "前往代币合约"
    }
  },
  "interestRateChart": {
    "currentUtilizationRateLabelValue": "当前（{{percentage}}）",
    "tooltipItemLabels": {
      "borrowApy": "借款 APY",
      "supplyApy": "存款 APY",
      "utilizationRate": "利用率"
    }
  },
  "isolatedPoolsSunsetBanner": {
    "description": "请立即提取或迁移所有资产",
    "illustrationAltText": "插图",
    "title": "隔离池已下线"
  },
  "kLineChart": {
    "disclaimer": {
      "buttonLabel": "聚合定价",
      "description": "价格数据仅供参考，已从多个来源聚合。实际链上 AMM 价格可能会有所不同。",
      "title": "图表信息"
    }
  },
  "landing": {
    "benefits": {
      "text1": "直接在链上访问不可篡改的货币市场。",
      "text2": "所有 Venus Protocol 资产均符合 BEP-20 和 ERC-20 标准。",
      "text3": "构建于兼容 EVM 的链上，实现快速、安全、低成本交易。",
      "title1": "去中心化",
      "title2": "BEP-20/ERC-20",
      "title3": "全链"
    },
    "governance": {
      "backgroundGradientAlt": "背景插图",
      "buttonLabel": "治理论坛",
      "description": "Venus 是由社区驱动的去中心化协议，为加密货币市场提供一流功能。",
      "proposalCountLegend": "Venus 改进提案已执行并持续增加",
      "title": "由社区治理的<br />货币市场"
    },
    "hero": {
      "1Year": "1年",
      "30Day": "30天",
      "6Month": "6个月",
      "assets": "资产",
      "borrow": "借款",
      "earned": "已赚取",
      "earnedAmount": "已赚取 {{amount}}",
      "from": "来自 {{percentage}}",
      "highestApy": "最高 APY",
      "monthNo": "第 {{number}} 个月",
      "startNow": "立即开始",
      "subtitle": "适用于任何 DeFi 收益策略的简单而强大的借贷。",
      "supply": "存款",
      "supplyTips": "基于 10,000 美元的初始存款，收益/利息按区块复利计算。<Link>了解更多</Link>",
      "title": "通用<br /><hl>货币市场</hl>",
      "totalApy": "总 APY",
      "upToPercentage": "最高 {{percentage}}",
      "venusTvl": "Venus TVL",
      "yearlyEarnings": "年收益",
      "yearlyInterests": "年利息"
    },
    "markets": {
      "button": {
        "label": "查看更多"
      },
      "title": "Venus 顶级市场"
    },
    "protection": {
      "bugBountyAlt": "漏洞赏金插图",
      "challengeText": "在我们的代码中寻找并报告漏洞即可获得奖励资格。了解更多请阅读我们的漏洞赏金计划。",
      "challengeTitle": "挑战我们的代码并获得奖励",
      "protectionAlt": "保护插图",
      "protectionText": "安全审计、7x24 监控以及强健的风险基金可在异常市场事件中保障协议安全。",
      "protectionTitle": "安全保障优先"
    },
    "safety": {
      "audit_one": "审计",
      "audit_other": "审计",
      "otherAuditors": "+14 次审计，来自 <br />Fairyproof、Hacken 和 HashEx",
      "scoreAlt": "评分插图",
      "securityScore": "安全评分",
      "text": "放心交易，Venus 将您的资产安全置于首位",
      "title": "安全第一",
      "venusScored": "Venus 在 Certik 的评估中于 BNB Chain 安全性排名 <Link>第 3</Link>（2021 年 6 月）"
    },
    "venusPrime": {
      "illustrationAlt": "Venus Prime 插图",
      "imageAlt": "Venus Prime 插图",
      "learnMore": "了解更多",
      "text": "Venus Protocol 的高阶用户可铸造 Venus Prime 代币，在 Venus core 池的部分市场享受更优费率。",
      "title": "<hl>Venus Prime</hl> <br />提升您的回报"
    },
    "wallets": {
      "title": "深受众多用户信赖"
    }
  },
  "layout": {
    "chainSelect": {
      "label": "选择链"
    },
    "header": {
      "liquidity": "流动性",
      "maxLtv": {
        "label": "最大 LTV",
        "modeInfoHint": "<Link>探索</Link>可用的 LTV 选项。",
        "tooltip": "最大 LTV 即借款限额。在 {{maxLtv}} LTV 下，1 {{tokenSymbol}} 的可抵押允许借入价值 {{userCollateralFactor}} {{tokenSymbol}} 的货币。"
      },
      "price": "价格",
      "resilientOracle": "弹性预言机",
      "supply": "存款",
      "utilizationRate": "利用率"
    },
    "menu": {
      "beta": "beta",
      "dashboard": {
        "label": "仪表盘"
      },
      "label": "菜单",
      "markets": {
        "label": "市场"
      },
      "others": {
        "bridge": {
          "description": "在 Venus 进行跨链 $XVS 转账。",
          "label": "跨链桥"
        },
        "governance": {
          "description": "使用 $XVS 投票 Venus 提案。",
          "label": "治理"
        },
        "label": "其他",
        "port": {
          "description": "无 Gas 导入借贷仓位。",
          "label": "迁移"
        },
        "stats": {
          "description": "实时风险参数",
          "label": "统计"
        },
        "swap": {
          "label": "兑换"
        },
        "trade": {
          "description": "做多一个、做空另一个,赚取价差。",
          "label": "Trade"
        },
        "vai": {
          "description": "铸造 Venus 的原生稳定币。",
          "label": "VAI"
        }
      },
      "prime": {
        "label": "Prime"
      },
      "settings": {
        "gasLessTransactions": {
          "label": "在 {{chainName}} 上启用免 gas 交易"
        },
        "language": {
          "label": "语言（测试版）"
        }
      },
      "subMenuItem": {
        "button": {
          "label": "开始使用"
        }
      },
      "vaults": {
        "label": "金库"
      },
      "venusLogoAlt": "Venus 标志"
    },
    "settingsModal": {
      "title": "设置"
    },
    "sunsetModal": {
      "description": "该链已下线。请偿还您的借款并提取已存入的资金。",
      "title": "已下线"
    },
    "testEnvWarning": "这是测试环境。除测试外请勿进行任何交互。<Link>前往 Venus Protocol 官方网站</Link>"
  },
  "layouts": {
    "menu": {
      "markets": {
        "venusCore": {
          "description": "经典借贷，轻松使用优化杠杆。",
          "label": "Venus Core"
        },
        "venusFlux": {
          "description": "高资本效率的借贷，以获得最佳收益。",
          "label": "Venus Flux"
        }
      }
    }
  },
  "legal": {
    "lastUpdatedAt": "最后更新：{{ date, textual }}"
  },
  "markdownEditor": {
    "markdownTabLabel": "撰写",
    "placeholder": "没有可预览的内容",
    "previewTabLabel": "预览"
  },
  "market": {
    "borrowCapThreshold": {
      "title": "总借款",
      "tooltip": "可借最大金额为 {{amountDollars}}（{{amountTokens}}）<br />借款上限：{{capTokens}}"
    },
    "borrowInfo": {
      "title": "借款信息"
    },
    "eModeInfo": {
      "eMode": {
        "title": "E-mode",
        "tooltip": "Boosts capital efficiency for correlated assets (e.g. stablecoins, LSTs) with better collateral factors and lower liquidation costs."
      },
      "isolationMode": {
        "title": "隔离模式",
        "tooltip": "A risk-containment mode for newer or more volatile assets."
      },
      "link": "显示全部市场",
      "table": {
        "columns": {
          "collateral": "可抵押",
          "group": "组",
          "isBorrowable": "可借",
          "liquidationPenalty": "罚金",
          "liquidationThreshold": "阈值",
          "maxLtv": "最大 LTV"
        }
      }
    },
    "interestRateModel": {
      "title": "利率模型"
    },
    "legends": {
      "borrowApy": "借款 APY",
      "supplyApy": "存款 APY",
      "utilizationRate": "利用率"
    },
    "marketInfo": {
      "stats": {
        "borrowerCountLabel": "借款人数",
        "collateralFactorLabel": "抵押系数 (Core)",
        "dailyBorrowingInterestsLabel": "每日借款利息",
        "dailyDistribution": "每日分发 {{tokenSymbol}}",
        "dailySupplyingInterestsLabel": "每日存款利息",
        "exchangeRateLabel": "兑换率",
        "exchangeRateValue": "1 {{tokenSymbol}}={{rate}} {{vTokenSymbol}}",
        "isBorrowableLabel": "可借 (Core)",
        "liquidationPenaltyLabel": "清算罚金 (Core)",
        "liquidationThresholdLabel": "清算阈值 (Core)",
        "no": "否",
        "reserveFactorLabel": "准备金系数",
        "supplierCountLabel": "存款人数",
        "yes": "是"
      }
    },
    "periodOption": {
      "oneYear": "1年",
      "sixMonths": "6个月",
      "thirtyDays": "30天"
    },
    "stats": {
      "apy": "当前 APY",
      "averageApy": "平均 APY",
      "liquidationPenalty": "清算罚金",
      "liquidationThreshold": "清算阈值"
    },
    "supplyCapThreshold": {
      "title": "总存款",
      "tooltip": "可存款最大金额为 {{amountDollars}}（{{amountTokens}}）"
    },
    "supplyInfo": {
      "title": "存款信息"
    }
  },
  "markets": {
    "eMode": {
      "table": {
        "card": {
          "header": {
            "borrowable": "可借",
            "collateral": "可抵押"
          }
        }
      }
    },
    "errors": {
      "accountError": "需要账户 - 请连接钱包。",
      "collateralDisableError": "禁用可抵押错误 - 禁用 {{assetName}} 作为可抵押时出现问题。请重试。",
      "collateralEnableError": "启用可抵押错误 - 启用 {{assetName}} 作为可抵押时出现问题。请重试。",
      "collateralRequired": "需要可抵押 - 请偿还所有借款资产或将其他资产设为可抵押。"
    },
    "header": {
      "venusCore": {
        "description": "面向全球的简单而强大、社区驱动的金融。",
        "title": "Venus Core"
      }
    },
    "isolatedEModeGroupTooltip": {
      "content": "仅向 {{ eModeGroupName }} 组内资产存款可提升你的借款能力",
      "label": "隔离"
    },
    "tabs": {
      "eMode": {
        "eModeNotice": "启用 E-mode 可最大化你的借款能力，但借款仅限于所选组内资产。<Link>了解更多</Link>",
        "group": {
          "cannotDisable": {
            "tooltip": {
              "blockingPositions": "你无法禁用该组，因为你有包含无法从该池借款的资产的借款仓位。<Link>显示我的仓位</Link>",
              "notEnoughCollateral": "你无法禁用该组，因为你的总可抵押价值不足以覆盖总借款余额"
            }
          },
          "cannotEnable": {
            "modal": {
              "description": "要启用 <WhiteText>{{ eModeGroupName }}</WhiteText> 组，你需要关闭以下借款仓位：",
              "repayButtonLabel": "还款",
              "title": "你的仓位"
            },
            "tooltip": {
              "blockingPositions": "你无法启用该组，因为你有不属于该组的资产借款仓位。<Link>显示我的仓位</Link>",
              "notEnoughCollateral": "你无法启用该组，因为你的总可抵押价值不足以覆盖总借款余额"
            }
          },
          "disableButtonLabel": "禁用",
          "disabledNotice": "该组已不再支持。你的账户将回到核心池参数。请切换到其他可用组或将其禁用。",
          "enableButtonLabel": "启用",
          "healthFactor": "健康系数：",
          "switchButtonLabel": "切换"
        },
        "isolationModeNotice": "启用隔离模式可最大化你的借款能力，但存款和借款仅限于所选组内资产。<Link>了解更多</Link>",
        "label": "E-mode",
        "table": {
          "columns": {
            "asset": "资产",
            "collateral": "可抵押",
            "isBorrowable": "可借",
            "liquidationPenalty": "清算罚金",
            "liquidationThreshold": "清算阈值",
            "maxLtv": "最大 LTV",
            "penalty": "罚金",
            "threshold": "阈值"
          },
          "mobileSelectLabel": "排序：",
          "searchPlaceholder": "搜索资产或组"
        }
      },
      "isolationMode": {
        "label": "隔离模式"
      },
      "markets": {
        "label": "市场"
      }
    }
  },
  "marketTable": {
    "assetColumn": {
      "eMode": "该市场属于 {{eModeGroupName}} E-mode组",
      "isolated": "隔离",
      "isolatedTooltip": "该资产仅在对应的隔离模式中可用。",
      "isolationMode": "该市场属于 {{eModeGroupName}} 隔离模式组",
      "pausedAssetTooltip": "资产已被 Venus 治理暂停。借款与存款已禁用。",
      "protectionMode": "由于价格波动，{{tokenName}} 的保护模式已激活，影响其抵押和借款价格。 <LearnMore>了解更多</LearnMore>",
      "protectionModeBorrow": "该市场正经历高波动性。<LineBreak/><LineBreak/>受保护的借款价值按 {{protectedValue}} 计算，代表计入您借款额度的保守价值。",
      "protectionModePair": "由于价格波动，{{tokenName}} 的保护模式已激活，影响其抵押和借款价格。 <LearnMore>了解更多</LearnMore>",
      "protectionModeSupply": "该市场正经历高波动性。<LineBreak/><LineBreak/>受保护的抵押品价值按 {{protectedValue}} 计算，代表用于确定您借款额度的保守价值。"
    },
    "columnKeys": {
      "asset": "资产",
      "assetAndChain": "资产",
      "borrowApy": "APY <InfoIcon />",
      "borrowBalance": "总借款",
      "collateral": "可抵押",
      "labeledBorrowApy": "借款 APY <InfoIcon />",
      "labeledSupplyApy": "存款 APY <InfoIcon />",
      "liquidity": "流动性",
      "price": "价格",
      "supplyApy": "APY <InfoIcon />",
      "supplyBalance": "总存款",
      "userBorrowBalance": "余额",
      "userBorrowLimitSharePercentage": "限额 %",
      "userSupplyBalance": "余额",
      "userWalletBalance": "钱包"
    },
    "columnSelectOptionLabel": {
      "asset": "资产",
      "borrowApy": "借款 APY",
      "borrowBalance": "总借款",
      "collateral": "可抵押",
      "labeledBorrowApy": "借款 APY",
      "labeledSupplyApy": "存款 APY / LTV",
      "liquidity": "流动性",
      "price": "价格",
      "supplyApy": "存款 APY / LTV",
      "supplyBalance": "总存款",
      "userBorrowBalance": "借款余额",
      "userBorrowLimitSharePercentage": "限额 %",
      "userSupplyBalance": "存款余额",
      "userWalletBalance": "钱包余额"
    },
    "columnTooltips": {
      "borrowApy": "借款 APY 为正表示你需要支付利息，为负表示你将获得利息",
      "supplyApy": "存款 APY 为正表示你将获得利息，为负表示你需要支付利息"
    },
    "pausedAssetsPlaceholder": {
      "description": "请启用“已暂停资产”开关以查看。",
      "imgAlt": "暂停图标",
      "title": "该池内所有资产已暂停"
    },
    "search": {
      "placeholder": "搜索资产"
    }
  },
  "operationForm": {
    "acknowledgements": {
      "highPriceImpact": {
        "label": "我已知悉高价格影响",
        "tooltip": "该交易预计价格影响将超过 {{priceImpactPercentage}}%"
      },
      "riskyOperation": {
        "label": "我已知悉相关风险",
        "tooltip": "此交易后你的健康系数将较低，清算风险增加"
      }
    },
    "availableAmount": "可用",
    "boostTabAltText": "火箭图标",
    "boostTabTitle": "收益加成",
    "borrow": "借款",
    "borrowTabTitle": "借款",
    "collateral": "可抵押",
    "collateralField": {
      "label": "可抵押"
    },
    "error": {
      "borrowCapReached": "该池借款上限 {{assetBorrowCap}} 已达。除非还款或提高借款上限，否则无法再从该市场借款。",
      "higherThanAvailableAmount": "输入金额超过可用金额",
      "higherThanAvailableLiquidity": "资产流动性不足",
      "higherThanBorrowBalance": "输入金额超过借款余额",
      "higherThanBorrowCap": "该市场借款上限为 {{assetBorrowCap}}，当前已借 {{assetBorrowBalance}}，因此你无法从该池借款超过 {{userMaxBorrowAmount}}。",
      "higherThanRepayBalance": "输入金额超过还款余额",
      "higherThanSupplyCap": "该市场存款上限为 {{assetSupplyCap}}，当前已存款 {{assetSupplyBalance}}，因此你无法向该池存款超过 {{userMaxSupplyAmount}}。",
      "higherThanWalletBalance": "{{tokenSymbol}} 余额不足",
      "higherThanWalletSpendingLimit": "你输入的金额超过该资产的支出限额。请先撤销支出限额并设置新的限额后再继续交易。",
      "noCollateral": "在从该池借入 {{tokenSymbol}} 之前，你需要先存款代币并将其设为可抵押",
      "noSwapQuoteFound": "未找到兑换。",
      "priceImpactTooHigh": "价格影响过高",
      "smallerThanMinimumAmount": "你不能一次存入少于 {{minAmount}}",
      "supplyCapReached": "该池存款上限 {{assetSupplyCap}} 已达。除非有人取款或提高存款上限，否则无法再向该市场存款。",
      "tooRisky": "该交易会导致账户被清算"
    },
    "leverageFactor": "{{ leverageFactor }}x",
    "leverageFactorModal": {
      "maximumShortAmount": "当前杠杆下的最大仓位：{{ value }}",
      "submitButtonLabel": "确认",
      "title": "杠杆倍数",
      "warning": "杠杆会影响你的资金利用率，并且在你完全平仓前无法更改。"
    },
    "managePositionsTabs": {
      "collateral": "可抵押",
      "position": "仓位",
      "positionsTabs": {
        "increase": "增加",
        "reduce": "减少",
        "supply": "存款",
        "withdraw": "取款"
      }
    },
    "receiveNativeToken": {
      "label": "接收 {{tokenSymbol}}",
      "tooltip": "将借入的 {{wrappedNativeTokenSymbol}} 解包为 {{nativeTokenSymbol}}"
    },
    "repaidField": {
      "label": "待还债务"
    },
    "repay": {
      "fullRepaymentWarning": "交易金额可能略高于当前借款金额以覆盖新产生的利息",
      "swappingWithHighPriceImpactWarning": "该交易价格影响较高，可能意味着不利的兑换。请确保兑换率和兑换数量符合预期。"
    },
    "repayTab": {
      "collateralTabTitle": "可抵押",
      "noCollateralWarning": "你没有可用于还款的可抵押资产。",
      "title": "还款",
      "walletBalanceTabTitle": "钱包"
    },
    "rightMaxButtonLabel": "最大",
    "riskSlider": {
      "0": "0%",
      "100": "100%"
    },
    "safeMaxButtonLabel": "安全最大值",
    "submitButtonLabel": {
      "boost": "收益加成",
      "borrow": "借款",
      "enterValidAmount": "输入有效金额",
      "repay": "还款",
      "supply": "存款",
      "withdraw": "取款"
    },
    "supply": "存款",
    "supplyTabTitle": "存款",
    "swapDetails": {
      "label": {
        "repay": "你将还款",
        "supply": "你将存款"
      },
      "value": {
        "estimatedAmount": "≈ {{ value }}",
        "exactAmount": "{{ value }}"
      }
    },
    "walletBalance": "钱包余额",
    "withdrawTabTitle": "取款"
  },
  "pagination": {
    "itemOf": "第 {{currentPageLastIndex}} 条 / 共 {{itemsCount}} 条",
    "itemsOf": "第 {{firstItemNumber}} - {{currentPageLastIndex}} 条 / 共 {{itemsCount}} 条"
  },
  "pendleVaultBanner": {
    "description": "一键即可在 <White>Venus</White> 上获取 Pendle 收益",
    "illustrationAltText": "金库插图",
    "title": "Pendle 金库现已开放"
  },
  "poolsStats": {
    "cell": {
      "assetsLabel": "资产",
      "availableLiquidityLabel": "可用流动性",
      "dailyXvsDistributionLabel": "每日 XVS 分发",
      "totalBorrowLabel": "总借款",
      "totalSupplyLabel": "总存款",
      "treasuryLabel": "金库"
    }
  },
  "primeButton": {
    "primeLogoAlt": "Venus Prime 标志"
  },
  "primeCalculator": {
    "borrowedTokens": {
      "infos": {
        "label": "合格借入 {{tokenSymbol}}",
        "tooltip": "借款上限：{{borrowCapTokens}}（{{borrowCapUsd}}）",
        "tooltip_empty": "借款上限：-"
      },
      "textField": {
        "label": "已借入 {{tokenSymbol}}"
      }
    },
    "rewardDetails": {
      "fromBorrowedTokens": "来自借入 {{tokenSymbol}}",
      "fromSuppliedTokens": "来自存款 {{tokenSymbol}}",
      "primeBorrowApy": {
        "title": "Prime 借款 APY",
        "tooltip": "将添加到市场借款 APY 的 Prime 加成。<Link>了解更多</Link>"
      },
      "primeSupplyApy": {
        "title": "Prime 存款 APY",
        "tooltip": "将添加到市场存款 APY 的 Prime 加成。<Link>了解更多</Link>"
      },
      "title": "奖励详情",
      "totalDailyRewards": {
        "title": "每日奖励总额",
        "tooltip": "Prime 用户一天内分发的所有奖励数量"
      },
      "yourDailyRewards": "你的每日奖励"
    },
    "stakedTokens": {
      "infos": {
        "error": "要符合 Prime 奖励资格，至少需供应 {{minimumXvsStaked}} XVS。",
        "label": "合格供应 XVS",
        "tooltip": "最多 {{maximumXvsStaked}} 将计入你的 Prime 奖励"
      },
      "textField": {
        "label": "已供应 XVS"
      }
    },
    "suppliedTokens": {
      "infos": {
        "label": "合格存款 {{tokenSymbol}}",
        "tooltip": "存款上限：{{supplyCapTokens}}（{{supplyCapUsd}}）",
        "tooltip_empty": "存款上限：-"
      },
      "textField": {
        "label": "已存款 {{tokenSymbol}}"
      }
    },
    "tokenSelect": {
      "label": "代币"
    },
    "topMessage": "你可以使用 Prime 计算器基于持仓估算持有 Prime 代币可获得的奖励。<Link>了解更多</Link>"
  },
  "primeLeaderboard": {
    "description": "将 XVS 质押到治理金库，在收益之上再赚取 Prime 奖励。",
    "endOfCycle": {
      "cycleEnded": "当前周期已结束，下个周期即将开始。",
      "days": "天",
      "deadline": "{{date, textualWithTime}}",
      "helper": "在 <Bold>{{deadline}}</Bold> 之前保持在前 {{limit}} 名，即可在下个周期获得 Prime 奖励。<SummaryLink>查看上个周期的 Prime 总结</SummaryLink>。",
      "helperEnded": "在 <Bold>{{deadline}}</Bold> 之前保持在前 {{limit}} 名，即可在下个周期获得 Prime 奖励。",
      "hours": "时",
      "mins": "分",
      "sec": "秒",
      "title": "周期结束"
    },
    "lastCycleSummary": {
      "primeScoreLabel": "Prime 分数",
      "rankLabel": "你的排名",
      "rankMissed": "就差一点!你未进入上一周期前 {{limit}}。提升质押以在本周期获得资格。",
      "rankNoStake": "你在上一周期未质押 XVS。立即质押以获得 Prime 资格并赚取额外奖励。",
      "rankQualified": "恭喜!你在上一周期位列前 {{limit}},已获得 Prime 奖励资格。",
      "title": "上一周期 Prime 汇总",
      "userRewardsTitle": "你上一周期的 Prime 奖励"
    },
    "rankCard": {
      "connectPrompt": "连接钱包以查看你的 Prime 资格。",
      "eligible": "你当前已具备下个周期的 Prime 资格",
      "notEligible": "你当前不具备下个周期的 Prime 资格。",
      "primeScoreLabel": "Prime 分数",
      "rankLabel": "你的排名",
      "rulesButton": "规则",
      "stakeButton": "质押 XVS",
      "stakeMore": "质押更多 XVS 以在下个周期竞争 Prime。",
      "stakeMoreToCompete": "质押更多 XVS 以竞争 Prime。",
      "stakePrompt": "质押 XVS 以竞争 Prime。",
      "stakeToReachTop": "再质押 <Highlight>{{amount}} XVS</Highlight>，有机会在本周期结束前进入前 #{{limit}}，并在下个周期获得 Prime 资格。"
    },
    "rankFooter": {
      "learnMore": "从 <LeaderboardLink>Prime 排行榜</LeaderboardLink> 了解更多"
    },
    "rankTable": {
      "columns": {
        "primeScore": "Prime 分数",
        "wallet": "钱包"
      },
      "rankBadgeAlt": "排名 {{rank}} 徽章",
      "walletTooltip": "排名通过链上计算，可在 <BscScan>BscScan</BscScan> 上验证"
    },
    "rewardTable": {
      "columns": {
        "marketRewards": "{{symbol}} 奖励",
        "totalRewards": "总奖励",
        "wallet": "钱包"
      }
    },
    "rulesModal": {
      "boostColumn": "加成",
      "boostMax": "{{boost}}（上限）",
      "contribution": "对每笔存入，你的贡献为 <Highlight>XVS × 加成 × 持有天数</Highlight>。你的 Prime 总分是所有存入的总和。",
      "daysHeld": "{{range}} 天",
      "daysHeldColumn": "持有天数",
      "footer": "想在排行榜上更进一步：质押更多，持有更久。",
      "intro1": "你的 <Highlight>Prime 分数</Highlight> 决定你在排行榜上的位置。每月 <Highlight>前 {{limit}} 名</Highlight> 成为 Prime 持有者，共享当月奖励池。",
      "intro2": "你的分数同时奖励你质押 XVS 的 <Highlight>数量</Highlight> 和 <Highlight>时长</Highlight>。每笔存入都会根据其存放时间获得忠诚度加成：",
      "point1": "<Highlight>加成和计入天数均以 90 天为上限</Highlight> —— 持有更久不会进一步提升每 XVS 的分数。",
      "point2": "<Highlight>提取时？最新的存入会被优先扣除。</Highlight> 你最早、加成最高的质押会受到保护。",
      "point3": "分数 <Highlight>实时</Highlight> 更新 —— 但你的 Prime 状态在 <Highlight>每月快照</Highlight> 时锁定。",
      "thingsToKnowTitle": "需要了解的几点：",
      "title": "规则"
    },
    "tablesRefreshNote": "每小时刷新 · 上次刷新：{{date, distanceToNow}}前",
    "tabs": {
      "ranking": "排名",
      "rewards": "Prime 奖励"
    },
    "title": "Prime 排行榜",
    "totalRewards": {
      "title": "本周期已分配的 Prime 总奖励"
    },
    "userRewards": {
      "eligibleMessage": "你在本周期已具备分享 Prime 奖励的资格。在下方供给资产以分享奖励。",
      "marketActions": "打开市场操作",
      "notEligibleMessage": "你在本周期暂不具备分享 Prime 奖励的资格。质押 XVS 以在下一周期竞争 Prime。",
      "primeLogoAlt": "Venus Prime 标志",
      "rewardShareAriaLabel": "占总奖励的比例",
      "title": "你本周期的 Prime 奖励"
    }
  },
  "primeStatusBanner": {
    "becomePrimeTitle": "你现在可以成为 Prime 用户",
    "claimButtonLabel": "领取 Prime 代币",
    "description": {
      "primeCalculator": "再供应 <WhiteText>{{stakeDelta}}</WhiteText> 并等待 {{claimWaitingPeriod}} 即可领取 Prime 代币并提升收益。<Link>计算 Prime 奖励</Link>",
      "primeDoc": "再供应 <WhiteText>{{stakeDelta}}</WhiteText> 并等待 {{claimWaitingPeriod}} 即可领取 Prime 代币并提升收益。<Link>了解更多</Link>"
    },
    "noPrimeTokenWarning": {
      "text": "所有 Prime 代币已被领取",
      "tooltip": "目前所有 {{primeTokenLimit}} 个 Prime 代币均已被领取。如果持有人不再符合资格或我们增加数量，可能会有部分可用。"
    },
    "progressBar": {
      "ariaLabel": "你的当前 Prime 进度",
      "label": "已供应：<WhiteText>{{userStakedXvsTokens}} / {{minXvsToStakeForPrimeTokens}}</WhiteText>"
    },
    "promotionalTitle": "将收益提升高达 <GreenText>{{percentage}}</GreenText>",
    "stakeButtonLabel": "供应 XVS",
    "tokensLeft": "剩余 <WhiteText>{{count}}</WhiteText> 个 Prime 代币",
    "tokensLeft_one": "剩余 <WhiteText>{{count}}</WhiteText> 个 Prime 代币",
    "tokensLeft_many": "剩余 <WhiteText>{{count}}</WhiteText> 个 Prime 代币",
    "tokensLeft_other": "剩余 <WhiteText>{{count}}</WhiteText> 个 Prime 代币",
    "waitForPrimeTitle": "{{claimWaitingPeriod}} 后可领取 Prime 奖励"
  },
  "proposalList": {
    "selectOptions": {
      "all": {
        "label": "全部"
      }
    }
  },
  "proposalState": {
    "active": "进行中",
    "bridged": "已跨链",
    "canceled": "已取消",
    "defeated": "已否决",
    "executed": "已执行",
    "expired": "已过期",
    "failed": "失败",
    "pending": "待定",
    "queued": "排队中",
    "succeeded": "成功"
  },
  "protectionModeIndicator": {
    "detailedTooltip": "该市场正经历高波动性。<LineBreak/><LineBreak/>受保护的抵押品价格为 {{collateralPrice}}，用于确定您借款额度的保守价格。<LineBreak/><LineBreak/>受保护的借款价格为 {{borrowPrice}}，用于计算可借入该资产数量的保守价格。",
    "label": "已保护",
    "pairTokenNames": "{{longToken}} 和 {{shortToken}}"
  },
  "requestWithdrawalFromVestingVaultForm": {
    "withdrawalRequestList": {
      "approveToken": {
        "connectWalletMessage": "请连接钱包查看你的取款请求"
      },
      "emptyState": "你没有活跃的取款请求",
      "locked": "锁定至 {{date, numericWithTime}}",
      "title": "取款请求",
      "unlocked": "已解锁",
      "withdrawButtonLabel": "提取已解锁余额"
    }
  },
  "select": {
    "defaultLabel": "选择选项"
  },
  "selectTokenTextField": {
    "searchInput": {
      "placeholder": "搜索资产"
    }
  },
  "skillsPage": {
    "footer": {
      "tagline": "为 Venus Protocol 社区打造"
    },
    "header": {
      "beta": "BETA",
      "tagline": "面向 Venus Protocol 的 AI 驱动 DeFi 自动化",
      "title": "Venus Agent Skills"
    },
    "sections": {
      "installation": {
        "icon": "📦",
        "note": {
          "securityLabel": "🔐 安全提示：",
          "securityText": "你的私钥绝不会离开你的设备。智能体会使用你的钱包在本地执行交易。",
          "warningLabel": "⚠️ BETA 版本警告：",
          "warningText": "这是 Beta 版本。请自行承担使用风险。仅使用测试资金或小额资金。确认前请务必核对交易。"
        },
        "paragraph1": "安装 Venus Agent Skills 不到 5 分钟。请按以下步骤操作：",
        "repository": {
          "label": "代码仓库："
        },
        "steps": {
          "1": {
            "text": "<Bold>下载技能包</Bold>（来自<RepoLink>官方仓库</RepoLink>）"
          },
          "2": {
            "text": "<Bold>将其放入你的智能体 skills 目录：</Bold>"
          },
          "3": {
            "text": "<Bold>在 .env 文件中配置钱包凭据</Bold>："
          },
          "4": {
            "text": "<Bold>安装依赖：</Bold>"
          },
          "5": {
            "text": "<Bold>重启智能体</Bold>以加载新技能"
          }
        },
        "title": "安装方法"
      },
      "introduction": {
        "features": {
          "1": {
            "description": "像与人对话一样与智能体交流，无需技术术语",
            "title": "自然语言指令"
          },
          "2": {
            "description": "即时获取 APY、流动性和市场数据",
            "title": "实时市场数据"
          },
          "3": {
            "description": "AI 会分析你的钱包并推荐最优收益策略",
            "title": "智能推荐"
          },
          "4": {
            "description": "用简单指令完成存款、借款、还款和提取",
            "title": "交易自动化"
          },
          "5": {
            "description": "设置如“当 APY > 3% 时存入”之类的条件，让智能体自动执行",
            "title": "自动交易规则"
          },
          "6": {
            "description": "24/7 监控你的仓位、健康因子和收益",
            "title": "投资组合追踪"
          }
        },
        "highlight": "无论 DeFi 新手还是资深交易者，只要想节省时间并优化收益都非常适合。",
        "icon": "🚀",
        "paragraph1": "Venus Agent Skills 是一个 AI 驱动的自动化框架，可让你通过自然语言与 Venus Protocol 交互。无需在复杂的 DeFi 界面中操作，只要告诉 AI 智能体你想做什么即可。",
        "title": "什么是 Venus Agent Skills？"
      },
      "verification": {
        "dialog1": {
          "agentIntro": "🤖 智能体：“是的！我已安装 Venus Protocol 技能。我可以帮你：",
          "agentOutro": "你想做什么？”",
          "capabilities": {
            "1": "查看市场数据和 APY",
            "2": "分析你的钱包和 Venus 仓位",
            "3": "存入和提取资产",
            "4": "借款和还款",
            "5": "设置自动交易规则"
          },
          "user": "👤 你：“你安装了 Venus 技能吗？”"
        },
        "dialog2": {
          "agent": "🤖 智能体正在从 Venus Core Pool 获取实时数据...",
          "user": "👤 “显示按流动性排名前 5 的市场”"
        },
        "dialog3": {
          "agent": "🤖 智能体正在检查你的钱包，并显示你的供应、借款和健康因子...",
          "user": "👤 “我在 Venus Core/Flux 上的当前仓位是什么？”"
        },
        "dialog4": {
          "agent": "🤖 智能体正在分析你的钱包余额，并推荐最佳收益策略...",
          "user": "👤 “我想赚收益”"
        },
        "highlight": "如果智能体返回了市场数据或建议，恭喜你！Venus Agent Skills 已安装并可使用。🎉",
        "icon": "✅",
        "paragraph1": "安装后，请通过与智能体对话来确认 Venus Agent Skills 正常运行：",
        "paragraph2": "试试这些测试指令，确认一切运行正常：",
        "tip": {
          "label": "💡 提示：",
          "text": "先从只读指令（如查看市场）开始，再执行交易。这能帮助你熟悉智能体的能力。"
        },
        "title": "验证安装"
      }
    },
    "terminal": {
      "sequence": {
        "balance": {
          "1": {
            "amount": "0.004784",
            "token": "BNB"
          },
          "2": {
            "amount": "10.501949",
            "token": "USDT"
          },
          "3": {
            "amount": "4.000000",
            "token": "USDC"
          }
        },
        "header": {
          "currentPosition": "当前 Venus 仓位（Core Pool）：",
          "finalPosition": "最终仓位：",
          "recommendation": "建议：",
          "topMarkets": "按流动性排名前 5 的市场：",
          "updatedPosition": "更新后仓位：",
          "walletBalance": "当前钱包余额（BNB Chain）："
        },
        "market": {
          "1": {
            "borrow": "1.0841%",
            "liquidity": "$356,095,914.68",
            "name": "vBTC",
            "supply": "0.1711%"
          },
          "2": {
            "borrow": "0.8598%",
            "liquidity": "$300,845,581.93",
            "name": "vBNB",
            "supply": "0.1648%"
          },
          "3": {
            "borrow": "0.0514%",
            "liquidity": "$130,654,243.33",
            "name": "vSolvBTC",
            "supply": "0.0002%"
          },
          "4": {
            "borrow": "3.7054%",
            "liquidity": "$109,840,237.54",
            "name": "vUSDT",
            "supply": "1.8415%"
          },
          "5": {
            "borrow": "0.0000%",
            "liquidity": "$91,022,728.98",
            "name": "vasBNB",
            "supply": "0.0000%"
          }
        },
        "output": {
          "analyzingWallet": "正在分析你的钱包和 Venus 仓位...",
          "borrowAfterCleanup": "  借款：$0.50 → ~$0.000001（零头）",
          "cleaningBorrow": "正在清理借款仓位...",
          "depositAmount": "  数量：10 USDT → vUSDT（Core Pool）",
          "fetchingMarkets": "正在获取 Venus Core Pool 市场数据...",
          "healthAfterCleanup": "  健康因子：34.14 → ~17,656,287",
          "initiatingDeposit": "正在发起存款交易...",
          "processingWithdrawal": "正在处理提取...",
          "recommendationAmount": "   建议数量：10 USDT",
          "recommendationApy": "   预期 APY：~1.84%（~0.184 USDT/年）",
          "recommendationTitle": "💡 将 USDT 存入 Venus Core Pool",
          "ruleAction": "  操作：存入钱包中的全部 USDC",
          "ruleId": "  任务 ID：eadf856a-393b-4587-aa69-10b252c22efa",
          "ruleInterval": "  间隔：每 10 分钟检查一次",
          "ruleTrigger": "  触发条件：vUSDC 存款 APY > 3.0%",
          "settingRule": "正在设置自动存款规则...",
          "walletUsdtAfterWithdrawal": "  钱包 USDT：10.001736",
          "withdrawalAmount": "  数量：从 vUSDT 提取 10 USDT"
        },
        "position": {
          "current": {
            "1": {
              "label": "总供应",
              "value": "$11.003238"
            },
            "2": {
              "label": "总借款",
              "value": "$0.500249"
            },
            "3": {
              "label": "健康因子",
              "status": "低风险",
              "value": "18.15"
            }
          },
          "final": {
            "1": {
              "label": "总供应",
              "value": "$11.003250"
            },
            "2": {
              "label": "总借款",
              "value": "~$0.000001"
            },
            "3": {
              "label": "健康因子",
              "status": "非常安全",
              "value": "~9,384,800"
            }
          },
          "updated": {
            "1": {
              "change": "+$10.00",
              "label": "总供应",
              "value": "$21.003943"
            },
            "2": {
              "change": "已改善",
              "label": "健康因子",
              "value": "34.14"
            }
          }
        },
        "success": {
          "borrowCleaned": "✓ 借款仓位清理成功",
          "depositComplete": "✓ 存款执行成功",
          "ruleEnabled": "✓ 自动交易规则已启用",
          "withdrawalComplete": "✓ 提取完成"
        },
        "tx": {
          "approve": {
            "hash": "0xa66216ffb5de805e1d870bfa6dc8ce43af8c85935c0423e2cd779a1b4e3bae2a",
            "label": "授权"
          },
          "approveBorrow": {
            "hash": "0x2539aebcf903c14dfc28c3757ccd358f1da7afe7c5334691a800e35523624049",
            "label": "授权"
          },
          "deposit": {
            "hash": "0x7d485c4022644db464262a56b46ef5740909c890566d0f001895938fde3bc620",
            "label": "存款"
          },
          "repay": {
            "hash": "0xdbccf6a5e9dc1ea5727115e86c9081646bf2c00a908512e7d9705f6e245930db",
            "label": "还款"
          },
          "withdraw": {
            "hash": "0x4d313a66b6c966b543bfc874e4c5fa78c55b1a4c284bac224ff22fc4066abe91",
            "label": "取款"
          }
        },
        "user": {
          "autoDepositRule": "当 APY 超过 3% 时，自动存入我钱包中的全部 USDC",
          "cleanupBorrow": "帮我清理借款",
          "confirmDeposit": "确认存款",
          "showTopMarkets": "给我显示按流动性排名前 5 的市场",
          "wantToEarn": "我想赚收益",
          "withdrawRequest": "帮我提取 10 USDT"
        }
      },
      "title": "Venus-agent.md"
    }
  },
  "spendingLimit": {
    "label": "支出限额",
    "labelTooltip": "这是你当前对该资产的支出上限。如需更多支出，请撤销上限并重新设置。",
    "revokeButtonTooltip": "撤销支出限额"
  },
  "statsPage": {
    "illustrationAlt": "统计插图",
    "poweredBy": "由 <Link>{{provider}}</Link> 提供支持",
    "subtitle": "Venus Protocol 市场的实时风险参数",
    "title": "Venus 统计"
  },
  "swap": {
    "errors": {
      "amountAboveWalletSpendingLimit": "你输入的金额超过该资产的支出限额。请撤销上限并重新设置后再继续交易。",
      "incorrectSwapInput": "兑换输入不正确"
    },
    "swapDetails": {
      "label": {
        "exchangeRate": "兑换率",
        "maximumSold": "最大卖出",
        "minimumReceived": "最小接收",
        "priceImpact": "价格影响",
        "slippageTolerance": "滑点容忍度"
      },
      "tooltip": {
        "priceImpact": "由于交易规模导致的市场价格与估算价格差异。"
      },
      "value": {
        "exactAmount": "{{ value }}",
        "exchangeRate": "1 {{fromTokenSymbol}} ≈ {{rate}} {{toTokenSymbol}}",
        "priceImpact": "{{ priceImpact }}"
      }
    },
    "warning": {
      "swappingWithHighPriceImpactWarning": "该交易价格影响较高，可能意味着不利的兑换。请确保兑换率和兑换数量符合预期。"
    }
  },
  "swapDetails": {
    "priceImpact": {
      "label": "价格影响"
    },
    "slippageTolerance": {
      "label": "滑点容忍度"
    },
    "slippageToleranceModal": {
      "description": "设置较高的滑点容忍度有助于交易成功，但可能无法获得理想价格。请谨慎使用。",
      "title": "滑点容忍度"
    }
  },
  "swapPage": {
    "connectWalletToSwap": "请连接钱包以兑换代币",
    "fromTokenAmountField": {
      "label": "从",
      "max": "最大"
    },
    "submitButton": {
      "disabledLabels": {
        "insufficientLiquidity": "兑换流动性不足",
        "insufficientUserBalance": "{{tokenSymbol}} 余额不足",
        "invalidFromTokenAmount": "输入有效兑换金额",
        "priceImpactHigherThanMaximumTolerated": "价格影响过高",
        "processing": "处理中",
        "spendingLimitTooLow": "支出限额过低",
        "unwrappingUnsupported": "不支持解包",
        "wrappingUnsupported": "不支持封装"
      },
      "enabledLabels": {
        "swap": "兑换",
        "swapWithHighPriceImpact": "高价格影响兑换"
      }
    },
    "toTokenAmountField": {
      "label": "到"
    },
    "walletBalance": "钱包余额"
  },
  "switchChain": {
    "switchButton": "切换到 {{chainName}}"
  },
  "switchChainNotice": {
    "buttonLabel": "切换到 {{chainName}}",
    "description": "你需要切换到 {{chainName}} 以启用或禁用可抵押品"
  },
  "table": {
    "cardsSelect": {
      "label": "排序"
    }
  },
  "tokenTextField": {
    "valueDollars": "≈ {{ value }}"
  },
  "trade": {
    "banner": {
      "illustrationAltText": "Trade 插图",
      "learnMore": "了解更多",
      "title": "什么是 Trade？"
    },
    "closePositionModal": {
      "title": "关闭"
    },
    "longLiquidity": "多头流动性",
    "longSupplyApy": "{{ longTokenSymbol }} 存款 APY",
    "longTokenSelect": {
      "label": "多头"
    },
    "operationForm": {
      "increaseForm": {
        "submitButtonLabel": "增加"
      },
      "invalidLiquidationPrice": "不适用",
      "openForm": {
        "collateral": "可抵押",
        "dsaFieldLabel": "可抵押",
        "dsaFieldPlaceholder": "输入以继续",
        "entryPrice": "开仓价",
        "liquidationPrice": "清算价",
        "long": "多头",
        "longFieldLabel": "多头",
        "netApy": "净 APY",
        "pnl": "已实现盈亏",
        "short": "空头",
        "shortFieldLabel": "空头",
        "submitButtonLabel": "开仓"
      },
      "reduceForm": {
        "submitButtonLabel": {
          "close": "关闭",
          "reduce": "减少"
        }
      },
      "supplyDsaForm": {
        "submitButtonLabel": "存款"
      },
      "walletBalance": "钱包余额",
      "warning": {
        "cannotBorrowShort": "该仓位的空头代币借款已被禁用",
        "cannotRepayShort": "该仓位的空头代币还款已被禁用",
        "cannotSupplyDsa": "该仓位的抵押品代币存款已被禁用",
        "cannotSupplyLong": "该仓位的多头代币存款已被禁用",
        "cannotWithdrawDsa": "该仓位的抵押品代币取款已被禁用",
        "cannotWithdrawLong": "该仓位的多头代币取款已被禁用",
        "notEnoughLeverage": "该代币对不支持至少 {{ minimumLeverageFactor }} 的杠杆倍数，而这是开立 Trade 仓位所需的最低值",
        "txLikelyToFail": "此交易涉及低价值兑换，可能会失败"
      },
      "withdrawDsaForm": {
        "submitButtonLabel": "取款"
      }
    },
    "positions": {
      "closeButtonLabel": "关闭",
      "placeholder": {
        "title": "暂无仓位"
      },
      "status": {
        "collateralColumn": {
          "label": "可抵押"
        },
        "collateralUtilizationColumn": {
          "label": "抵押品利用率"
        },
        "healthFactor": {
          "label": "健康系数",
          "tooltip": "清算阈值 < 1.0"
        },
        "netApy": {
          "label": "净 APY"
        },
        "netValue": {
          "label": "净值"
        },
        "title": "状态"
      },
      "table": {
        "entryPrice": {
          "title": "EP",
          "tooltip": "该仓位的入场价格比率（空头资产数量 ÷ 多头资产数量，或多头资产数量 ÷ 空头资产数量，具体取决于所选基础代币），反映两种代币在入场时的相对价值。"
        },
        "liquidationPrice": {
          "title": "清算价",
          "tooltip": "清算价格基于当前基础代币价格计算，并可能随着基础代币价格变动而变化。请始终关注健康系数（HF）。"
        },
        "longColumn": {
          "title": "多头"
        },
        "pnlColumn": {
          "title": "盈亏"
        },
        "positionColumn": {
          "title": "仓位"
        },
        "shortColumn": {
          "title": "空头"
        }
      },
      "transactions": {
        "title": "交易"
      }
    },
    "shortBorrowApy": "{{ shortTokenSymbol }} 借款 APY",
    "shortLiquidity": "空头流动性",
    "shortTokenSelect": {
      "label": "空头"
    }
  },
  "tradeBanner": {
    "description": "在链上交易相对表现",
    "illustrationAltText": "Trade 插图",
    "title": "Venus Trade 现已上线"
  },
  "transactionErrors": {
    "acceptAdminPendingAdminCheck": "接受管理员待定检查",
    "acceptPendingImplementationAddressCheck": "接受待定实现地址检查",
    "accrueInterestAccumulatedInterestCalculationFailed": "累计利息计算失败",
    "accrueInterestBorrowRateCalculationFailed": "借款利率计算失败",
    "accrueInterestNewBorrowIndexCalculationFailed": "新借款指数计算失败",
    "accrueInterestNewTotalBorrowsCalculationFailed": "新总借款计算失败",
    "accrueInterestNewTotalReservesCalculationFailed": "新总准备金计算失败",
    "accrueInterestSimpleInterestFactorCalculationFailed": "简单利息因子计算失败",
    "addReservesAccrueInterestFailed": "增加准备金利息累计失败",
    "addReservesFreshCheck": "增加准备金新鲜度检查",
    "addReservesTransferInNotPossible": "增加准备金无法转入",
    "badInput": "输入错误",
    "borrowAccrueInterestFailed": "借款利息累计失败",
    "borrowAccumulatedBalanceCalculationFailed": "借款累计余额计算失败",
    "borrowCashNotAvailable": "借款现金不可用",
    "borrowComptrollerRejection": "借款 Comptroller 拒绝",
    "borrowFreshnessCheck": "借款新鲜度检查",
    "borrowMarketNotListed": "借款市场未列出",
    "borrowNewAccountBorrowBalanceCalculationFailed": "新账户借款余额计算失败",
    "borrowNewTotalBalanceCalculationFailed": "新总余额计算失败",
    "comptrollerCalculationError": "Comptroller 计算错误",
    "comptrollerMismatch": "Comptroller 不匹配",
    "comptrollerRejection": "Comptroller 拒绝",
    "exitMarketBalanceOwed": "退出市场仍欠款余额",
    "exitMarketRejection": "退出市场被拒绝",
    "gasEstimationFailed": "Gas 估算失败",
    "gaslessTransactionNotAvailable": "免 gas 交易不可用",
    "insufficientBalanceForVai": "VAI 余额不足",
    "insufficientLiquidity": "流动性不足",
    "insufficientShortfall": "不足差额",
    "interestRateModelError": "利率模型错误",
    "invalidAccountPair": "账户对无效",
    "invalidCloseAmountRequested": "请求的关闭金额无效",
    "invalidCloseFactor": "关闭因子无效",
    "invalidCollateralFactor": "可抵押因子无效",
    "invalidLiquidationIncentive": "清算激励无效",
    "liquidateAccrueBorrowInterestFailed": "清算借款利息累计失败",
    "liquidateAccrueCollateralInterestFailed": "清算可抵押利息累计失败",
    "liquidateCloseAmountIsUintMax": "清算关闭金额为 UINT 最大值",
    "liquidateCloseAmountIsZero": "清算关闭金额为 0",
    "liquidateCollateralFreshnessCheck": "清算可抵押新鲜度检查",
    "liquidateComptrollerCalculateAmountSeizeFailed": "清算 Comptroller 计算扣押金额失败",
    "liquidateComptrollerRejection": "清算 Comptroller 拒绝",
    "liquidateFreshnessCheck": "清算新鲜度检查",
    "liquidateSeizeBalanceDecrementFailed": "清算扣押余额减少失败",
    "liquidateSeizeBalanceIncrementFailed": "清算扣押余额增加失败",
    "liquidateSeizeBorrowFreshFailed": "清算借款新鲜度检查失败",
    "liquidateSeizeComptrollerRejection": "清算扣押 Comptroller 拒绝",
    "liquidateSeizeIsBorrower": "清算扣押为借款人",
    "liquidateSeizeLiquidatorIsBorrower": "清算者为借款人",
    "liquidateSeizeTooMuch": "清算扣押过多",
    "marketAlreadyListed": "市场已列出",
    "marketNotEntered": "未进入市场",
    "marketNotFresh": "市场未更新",
    "marketNotListed": "市场未列出",
    "mathError": "数学错误",
    "mintAccrueInterestFailed": "铸造利息累计失败",
    "mintComptrollerRejection": "铸造 Comptroller 拒绝",
    "mintExchangeRateReadFailed": "铸造读取兑换率失败",
    "mintFeeCalculationFailed": "铸造费用计算失败",
    "mintFreshnessCheck": "铸造新鲜度检查",
    "mintNewAccountBalanceCalculationFailed": "铸造新账户余额计算失败",
    "mintNewTotalSupplyCalculationFailed": "铸造新总存款计算失败",
    "mintTransferInFailed": "铸造转入失败",
    "mintTransferNotPossible": "铸造无法转入",
    "noError": "无错误",
    "nonzeroBorrowBalance": "借款余额不为 0",
    "priceError": "价格错误",
    "redeemAccrueInterestFailed": "赎回利息累计失败",
    "redeemComptrollerRejection": "赎回 Comptroller 拒绝",
    "redeemExchangeAmountCalculatioFailed": "赎回兑换金额计算失败",
    "redeemExchangeRateReadFailed": "赎回读取兑换率失败",
    "redeemExchangeTokensCalculationFailed": "赎回兑换代币计算失败",
    "redeemFeeCalculationFailed": "赎回费用计算失败",
    "redeemFreshnessCheck": "赎回新鲜度检查",
    "redeemNewAccountBalanceCalculationFailed": "赎回新账户余额计算失败",
    "redeemNewTotalSupplyCalculationFailed": "赎回新总存款计算失败",
    "redeemTransferOutNotPossible": "赎回无法转出",
    "reduceReservesAccrueInterestFailed": "减少准备金利息累计失败",
    "reduceReservesAdminCheck": "减少准备金管理员检查",
    "reduceReservesCashNotAvailable": "减少准备金现金不可用",
    "reduceReservesFreshCheck": "减少准备金新鲜度检查",
    "reduceReservesValidation": "减少准备金验证",
    "rejection": "拒绝",
    "repayBehalfAccrueInterestFailed": "代为还款利息累计失败",
    "repayBorrowAccrueInterestFailed": "还款借款利息累计失败",
    "repayBorrowAccumulatedBalanceCalculationFailed": "还款借款累计余额计算失败",
    "repayBorrowComptrollerRejection": "还款 Comptroller 拒绝",
    "repayBorrowFreshnessCheck": "还款新鲜度检查",
    "repayBorrowNewAccountBorrowBalanceCalculationFailed": "还款新账户借款余额计算失败",
    "repayBorrowTransferInNotPossible": "还款无法转入",
    "repayBorrowTransferNotPossible": "还款无法转入",
    "repayVaiComptrollerRejection": "偿还 VAI Comptroller 拒绝",
    "repayVaiFreshnessCheck": "偿还 VAI 新鲜度检查",
    "setCloseFactorOwnerCheck": "设置关闭因子所有者检查",
    "setCloseFactorValidation": "设置关闭因子验证",
    "setCollateralFactorNoExists": "设置可抵押因子不存在",
    "setCollateralFactorOwnerCheck": "设置可抵押因子所有者检查",
    "setCollateralFactorValidation": "设置可抵押因子验证",
    "setCollateralFactorWithoutPrice": "设置可抵押因子无价格",
    "setComptrollerOwnerCheck": "设置 Comptroller 所有者检查",
    "setImplementationOwnerCheck": "设置实施所有者检查",
    "setInterestRateModelAccrueInterestFailed": "设置利率模型利息累计失败",
    "setInterestRateModelFreshCheck": "设置利率模型新鲜度检查",
    "setInterestRateModelOwnerCheck": "设置利率模型所有者检查",
    "setLiquidationIncentiveOwnerCheck": "设置清算激励所有者检查",
    "setLiquidationIncentiveValidation": "设置清算激励验证",
    "setMaxAssetsOwnerCheck": "设置最大资产所有者检查",
    "setMintedVaiRejection": "设置已铸 VAI 被拒绝",
    "setOracleMarketNotListed": "设置预言机市场未列出",
    "setPauseGuardianOwnerCheck": "设置暂停守护者所有者检查",
    "setPendingAdminOwnerCheck": "设置待定管理员所有者检查",
    "setPendingImplementationOwnerCheck": "设置待定实施所有者检查",
    "setPriceOracleOwnerCheck": "设置价格预言机所有者检查",
    "setReserveFactorAccrueInterestFailed": "设置准备金系数利息累计失败",
    "setReserveFactorAdminCheck": "设置准备金系数管理员检查",
    "setReserveFactorBoundsCheck": "设置准备金系数范围检查",
    "setReserveFactorFreshCheck": "设置准备金系数新鲜度检查",
    "setTreasuryOwnerCheck": "设置金库所有者检查",
    "setVaiControllerOwnerCheck": "设置 VAI 控制器所有者检查",
    "setVaiMintRateCheck": "设置 VAI 铸造率检查",
    "sftMintNewAccountBalanceCalculationFailed": "SFT 铸造新账户余额计算失败",
    "snapshotError": "快照错误",
    "supportMarketExists": "支持市场已存在",
    "supportMarketOwnerCheck": "支持市场所有者检查",
    "tokenGetUnderlyingPriceError": "获取代币底层价格失败",
    "tokenInsufficentCash": "代币现金不足",
    "tokenInsufficientAllowance": "代币授权不足",
    "tokenInsufficientBalance": "代币余额不足",
    "tokenPriceError": "代币价格错误",
    "tokenTransferInFailed": "代币转入失败",
    "tokenTransferOutFailed": "代币转出失败",
    "tooManyAssets": "资产过多",
    "tooMuchRepay": "还款过多",
    "transferComptrollerRejection": "转账 Comptroller 拒绝",
    "transferNotAllowed": "不允许转账",
    "transferNotEnough": "转账不足",
    "transferTooMuch": "转账过多",
    "unauthorized": "未授权",
    "vaiBurnRejection": "销毁 VAI 被拒绝",
    "vaiLiquidateAccrueBorrowInterestFailed": "清算 VAI 借款利息累计失败",
    "vaiLiquidateAccrueCollateralInterestFailed": "清算 VAI 可抵押利息累计失败",
    "vaiLiquidateCloseAmountIsUintMax": "清算 VAI 关闭金额为 UINT 最大值",
    "vaiLiquidateCloseAmountIsZero": "清算 VAI 关闭金额为 0",
    "vaiLiquidateCollateralFreshnessCheck": "清算 VAI 可抵押新鲜度检查",
    "vaiLiquidateComptrollerCalculateAmountSeizeFailed": "清算 VAI Comptroller 计算扣押金额失败",
    "vaiLiquidateComptrollerRejection": "清算 VAI Comptroller 拒绝",
    "vaiLiquidateFreshnessCheck": "清算 VAI 新鲜度检查",
    "vaiLiquidateLiquidatorIsBorrower": "清算 VAI 清算者为借款人",
    "vaiLiquidateRepayBorrowFreshFailed": "清算 VAI 还款新鲜度检查失败",
    "vaiLiquidateSeizeBalanceDecrementFailed": "清算 VAI 扣押余额减少失败",
    "vaiLiquidateSeizeBalanceIncrementFailed": "清算 VAI 扣押余额增加失败",
    "vaiLiquidateSeizeComptrollerRejection": "清算 VAI 扣押 Comptroller 拒绝",
    "vaiLiquidateSeizeLiquidatorIsBorrower": "清算 VAI 扣押者为借款人",
    "vaiLiquidateSeizeTooMuch": "清算 VAI 扣押过多",
    "vaiMintExchangeCalculationFailed": "铸造 VAI 兑换计算失败",
    "vaiMintRejection": "铸造 VAI 被拒绝"
  },
  "transactionNotification": {
    "couldNotFetchReceipt": {
      "title": "无法获取交易状态"
    },
    "failed": {
      "title": "交易失败"
    },
    "pending": {
      "title": "交易确认中"
    },
    "success": {
      "title": "交易已确认"
    }
  },
  "vai": {
    "borrow": {
      "amountTokensInput": {
        "limitButtonLabel": "安全最大值"
      },
      "availableAmount": {
        "label": "可用",
        "tooltip": "根据全局限额和你提供的可抵押，最多可借 VAI 数量"
      },
      "borrowApr": {
        "label": "借款 APR",
        "tooltip": "在已铸造 VAI 之外未来需支付的年化利率"
      },
      "fee": {
        "label": "费用"
      },
      "notice": {
        "amountHigherThanAccountMintableAmount": "输入金额超过可用金额",
        "amountHigherThanLiquidity": "输入金额超过可用 VAI 流动性"
      },
      "primeOnlyWarning": "仅持有 Prime 代币的用户可借 VAI。了解更多 Prime 信息 <Link>这里</Link>。",
      "submitButton": {
        "borrowLabel": "借款",
        "enterValidAmountLabel": "输入有效借款金额"
      },
      "tabTitle": "借款"
    },
    "headerMessage": "VAI 是 Venus 协议的主要稳定币。使用你提供的抵押物借入 VAI。<Link>了解更多</Link>",
    "repay": {
      "amountTokensInput": {
        "limitButtonLabel": "最大"
      },
      "borrowApr": {
        "label": "借款 APR",
        "tooltip": "在已铸造 VAI 之外未来需支付的年化利率"
      },
      "notice": {
        "amountHigherThanBorrowBalance": "输入金额超过还款余额",
        "amountHigherThanWalletBalance": "{{tokenSymbol}} 余额不足",
        "amountHigherThanWalletSpendingLimit": "你输入的金额超过该资产的支出限额。请先撤销限额并重新设置后再继续交易。",
        "fullRepaymentWarning": "交易金额可能略高于当前借款金额以覆盖新产生的利息"
      },
      "submitButton": {
        "enterValidAmountLabel": "输入有效还款金额",
        "repayLabel": "还款"
      },
      "tabTitle": "还款",
      "walletBalance": {
        "label": "钱包余额"
      }
    }
  },
  "vault": {
    "card": {
      "apr": "APR",
      "blockingPendingWithdrawalsWarning": "您必须先完成待处理的提款才能与此金库互动。",
      "collateral": "抵押品",
      "currentDeposited": "当前已供应",
      "dailyEmission": "每日奖励释放",
      "header": {
        "fixedTermTitle": "{{ tokenSymbol }} 固定期限",
        "maturityDate_other": "{{ date, textual }}（{{ count }}天）"
      },
      "liquidity": "流动性",
      "liquidityTooltip": "此金库底层 Pendle 集成资金池（或策略）中当前提供的资产总价值。",
      "maturityDate": "到期日",
      "maturityDatePendle": "到期日",
      "maturityDatePendleTooltip": "此固定收益头寸（来自 Pendle）的到期日。在此日期之后，您将收回全部原始资产（本金）。锁定的固定收益在此停止，建议持有至此以获得预期收益。",
      "minRequested": "最小请求量",
      "pausedWarning": "此金库目前已暂停。利率仍在累积，但领取、供应和提款功能已禁用，直至金库恢复运作。",
      "primeEligibility": "Prime 资格",
      "targetApr": "目标 APR",
      "targetAprTooltip": "此金库策略旨在实现的年化目标奖励，以包含复利的目标年化收益率（APR）表示。实际回报具有可变性，并取决于交易对手表现；本金存在风险。您收到的金额可能少于已供应的数量。",
      "textualWithTime": "{{date, textualWithTime}}",
      "totalDeposited": "总供应量",
      "vaultVenueIcon": "Venus 标志",
      "venue": "平台",
      "youDeposited": "你已供应"
    },
    "category": {
      "governance": "治理",
      "stablecoins": "稳定币",
      "yieldTokens": "收益代币"
    },
    "description": "轻松获取收益，让回报真正落地",
    "filter": {
      "active": "进行中",
      "allCategories": "所有类别",
      "allStates": "所有状态",
      "allVenues": "所有平台",
      "claim": "领取",
      "deposit": "供应",
      "inactive": "非活跃",
      "inputPlaceholder": "搜索资产",
      "liquidated": "已清算",
      "locked": "收益中",
      "paused": "已暂停",
      "pending": "待定",
      "refund": "退款",
      "repaying": "还款中"
    },
    "header": "金库",
    "modals": {
      "afterMaturityPendleDisclaimer": "请先通过取款按钮将您的 PT 代币提取到钱包，然后访问 <Link>Pendle 官方</Link>网站赎回您的底层代币。",
      "claim": "领取",
      "connectWalletMessage": "请连接您的钱包以与此金库交互",
      "convert": "转换",
      "currentDeposited": "当前已供应",
      "currentDepositedTooltip": "您当前在此金库中锁定并产生收益的资产数量。",
      "deposit": "供应",
      "depositPeriodEnds": "供应期结束",
      "depositsPausedNotice": "资金在供应期和锁定期内将被锁定，仅可在领取期或退款期领取。实际结果取决于交易对手表现，本金存在风险，您收到的金额可能少于已供应的数量。",
      "depositTab": "供应",
      "error": {
        "amountTooLow": "输入金额过低。",
        "invalidAmountFromQuote": "输入金额超过Pendle市场的可用流动性。请减少金额后重试。",
        "lowerThanMinimumAmount": "输入金额过低。允许的最低金额相当于 {{amount}} USD。",
        "noSwapQuoteFound": "未找到兑换报价，请更新表单。",
        "pendleApiError": "Pendle 当前请求量较大，请稍后再试。"
      },
      "estPenalty": "预计罚款",
      "estReceived": "预计收到",
      "estYield": "预计奖励",
      "institutionalDisclaimer": "资金在供应期和锁定期内将被锁定，仅可在领取期或退款期领取。实际结果取决于交易对手表现，本金存在风险，您收到的金额可能少于已供应的数量。",
      "institutionalTcsAgreement": "继续操作即表示我同意 <Link>Venus 固定期限金库使用条款</Link>，并声明我不是受限制人士。受限制人士包括美国人士（定义见 1933 年美国证券法 Regulation S）、位于英国、加拿大或中国大陆境内、通常居住于上述地区或拥有其国籍的人士，以及位于 OFAC 制裁司法管辖区内或受其制裁法律约束的任何人士。完整名单请参阅使用条款。",
      "institutionalTimeline": {
        "claimPeriod": "预计领取期",
        "depositPeriod": "供应期",
        "estimatedLockedPeriod": "预计锁定期",
        "estimatedRepayingPeriod": "预计偿还期",
        "refundPeriod": "退款期"
      },
      "maturityDate": "到期日",
      "maturityDatePendle": "到期日",
      "maturityDatePendleTooltip": "此固定收益头寸（来自 Pendle）的到期日。在此日期之后，您将收回全部原始资产（本金）。锁定的固定收益在此停止，建议持有至此以获得预期收益。",
      "maturityPendleDisclaimer": "到期前，提款时收到的金额取决于 Pendle 市场价格。到期后，提款将根据您持有的 PT 代币 1:1 赎回。",
      "minReceived": "最低收到",
      "overview": {
        "campaignTimeline": "活动时间线",
        "collateral": "抵押品",
        "contractAddress": "合约地址",
        "loan": "贷款",
        "marketInfo": "市场信息",
        "marketRiskDisclosures": "市场风险披露",
        "riskDisclosureText": {
          "matrixDock": "<Bold>本金存在风险</Bold>。目标利率是浮动的，并与金库表现挂钩，不构成保证收益。<Bold>您拿回的金额可能少于投入金额</Bold>。在结算时，您将按份额获得该时点金库实际持有资产中的相应部分。<Bold>您的资金将被锁定</Bold>。锁定期开始后，您将无法供应或提取。只有在结算后资金才可领取。<Bold>影响结果的因素：</Bold>交易对手表现、抵押条件、智能合约执行、预言机可靠性以及结算结果。<Bold>受司法辖区限制</Bold>。该金库不向受限司法辖区或受限人士开放。完整名单请参阅使用条款。供应前，请查看本页的 <TermsOfUseLink>使用条款</TermsOfUseLink> 和金库参数。",
          "pendle": "Pendle 是一个去中心化收益交易协议，通过本金代币（PT）实现固定利率收益。Venus 固定利率金库通过 Pendle 的基础设施路由已供应的资产以获取 PT，并将其作为抵押品供应至 Venus Core。<br />虽然 Pendle 无法访问或转移您已供应的资金，但使用此金库会使您同时暴露于两个协议的风险。这些风险包括智能合约漏洞、预言机故障，以及任一协议被攻击或暂停的可能性。提前提款按市场价格执行，返还金额可能低于已供应金额。固定 APY 会在供应时锁定，但并不能防范协议层面的故障。"
        },
        "strategy": {
          "pendleRouter": "Pendle Router",
          "users": "用户",
          "venue": "平台",
          "venusCore": "Venus Core",
          "venusVault": "Venus 金库"
        },
        "strategyAllocation": "策略分配",
        "supply": "供应",
        "totalDeposited": "总供应量",
        "vaultDeploymentDate": "金库部署日期",
        "vaultVenueIcon": "平台标志",
        "venue": "平台",
        "venueTooltip": "在锁定期内持有并调配此金库底层资产的交易对手方。已供应的资产会按照预先约定的条款进行部署；赎回和结算时间表遵循金库公布的计划，只有在这些规则定义的特殊情况下才可能调整。"
      },
      "overviewTab": "概览",
      "pendleFee": "Pendle 费用",
      "positionTab": "持仓",
      "stakeTab": "供应",
      "targetApr": "目标 APR",
      "targetAprTooltip": "此金库策略旨在实现的年化目标奖励，以包含复利的目标年化收益率（APR）表示。实际回报具有可变性，并取决于交易对手表现；本金存在风险。您收到的金额可能少于已供应的数量。",
      "textualDate": "{{date, textual}}",
      "textualWithTime": "{{date, textualWithTime}}",
      "totalTargetRewards": "目标奖励总额",
      "withdraw": "取款",
      "withdrawTab": "取款"
    },
    "overview": {
      "bannerVaultIllustration": "金库插图"
    },
    "timeline": {
      "description": {
        "claim": "所有本金和已赚取的利息均可提取。",
        "deposit": "用户可在此期间自由供应 {{ tokenSymbol }}。",
        "locked": "供应和领取已暂停。锁定期将在待处理期结束且资金全部转移后开始。",
        "refund": "本金可提取。",
        "repaying": "金库已到期。本金和利息正在结算中。此过程通常需要 2-3 天。"
      },
      "tbd": "待定",
      "textualWithTime": "{{date, textualWithTime}}"
    }
  },
  "vaultCard": {
    "vaultModal": {
      "footer": {
        "currentlyStaked": "当前已供应",
        "estimatedDailyEarnings": "预估日收益",
        "lockingPeriod": {
          "duration": "{{date, distanceToNow}}",
          "label": "锁定期",
          "tooltip": "锁定期是指从提交取款请求到请求金额实际可从金库中取出的这段等待时间。"
        }
      },
      "requestWithdrawalFromVestingVaultForm": {
        "displayWithdrawalRequestListButton": {
          "label": "取款请求列表",
          "tooltip": "你有已解锁的 XVS 可领取。"
        },
        "primeLossWarning": {
          "message": "如果你提取该金额，你将失去 Prime 代币，因为你在 XVS 金库中的供应金额将低于获得 Prime 资格所需的最低值 {{minimumXvsStake}}。"
        },
        "requestWithdrawalField": {
          "label": "申请取款"
        },
        "submitButton": {
          "label": "申请取款"
        }
      },
      "stakeForm": {
        "depositField": {
          "label": "供应"
        },
        "footer": {
          "apr": "APR"
        },
        "submitButton": {
          "label": "供应"
        }
      },
      "withdrawFromVaiVault": {
        "submitButton": {
          "label": "取款"
        },
        "withdrawField": {
          "label": "取款"
        }
      }
    }
  },
  "venusFluxBanner": {
    "description": "仅限30天。5月28日携手<YellowText>Binance Wallet</YellowText>上线",
    "illustrationAltText": "Venus Flux 插图",
    "title": "Venus Flux 上线 5 万 USDT 奖励"
  },
  "vote": {
    "abstain": "弃权",
    "addComment": "添加评论",
    "against": "反对",
    "comment": "评论",
    "createProposalForm": {
      "abstainOption": "弃权选项",
      "action": "操作",
      "actions": "操作",
      "addDescription": "添加描述（支持基础 Markdown 样式）",
      "addOneMoreAction": "+ 添加一个操作",
      "address": "地址",
      "againstOption": "反对选项",
      "confirm": "确认",
      "create": "创建",
      "description": "描述",
      "forOption": "赞成选项",
      "name": "名称",
      "nextStep": "下一步",
      "proposalName": "提案名称",
      "proposalType": "提案类型",
      "signature": "签名",
      "submitError": "创建提案时出错",
      "votingOptions": "投票选项"
    },
    "createProposalModal": {
      "createManually": "手动创建",
      "createProposal": "创建提案",
      "uploadFile": "上传文件",
      "youCanEitherCreateManuallyOrUpload": "你可以手动创建提案，或上传包含详细信息的文件。如果选择上传文件，你可以使用该模板作为示例：<Link>Github</Link>"
    },
    "createProposalPlus": "+ 创建提案",
    "delegate": "委托",
    "delegateAddress": "委托地址",
    "delegateLeaderboard": "委托排行榜",
    "delegateVotes": "委托票数",
    "delegateVoting": "委托投票",
    "delegateYourVoting": "2. <Anchor>将你的投票权</Anchor>委托给自己或他人",
    "depositXvs": "供应 XVS",
    "depositYourTokens": "1. <Link>供应你的代币</Link> 到 XVS 金库 ",
    "enterContactAddress": "输入联系地址",
    "errorState": {
      "buttonLabel": "重试",
      "message": "提案获取失败"
    },
    "for": "赞成",
    "omnichain": {
      "switchToBnb": "切换到 BNB Chain",
      "votingOnlyEnabledOnBnb": "投票仅在 BNB Chain 上可用"
    },
    "pages": {
      "actions": "3 / 3 操作",
      "confirmation": "确认",
      "proposalInformation": "1 / 3 提案信息",
      "votingOptions": "2 / 3 投票选项"
    },
    "pasteYourAddress": "粘贴你的地址",
    "pleasePayAttention": "请注意",
    "proposals": "提案",
    "proposalStateFilter": {
      "label": "状态"
    },
    "proposalType": {
      "critical": "关键",
      "fastTrack": "快速通道",
      "normal": "普通"
    },
    "redelegate": "重新委托",
    "redelegateVoting": "重新委托投票",
    "requiredVotingPower": "你需要拥有 300k 投票权才能创建提案",
    "searchInput": {
      "placeholder": "搜索提案"
    },
    "summaryProgressBar": "投票总结进度条 - {{voteType}}",
    "totalLocked": "总锁定",
    "toVoteYouShould": "投票前你应：",
    "voteAbstain": "投票弃权",
    "voteAgainst": "投票反对",
    "voteFor": "投票赞成",
    "votingPower": "投票权",
    "votingWallet": "投票钱包",
    "votingWeight": "投票权重",
    "youCanDelegateVotes": "你可以将投票权委托给自己或他人。如果知道要委托的地址，请在下方输入；否则可查看委托排行榜来选择支持的政党",
    "youDelegatedTo": "你已将锁定的代币委托给 {{delegate}}"
  },
  "voteProposalUi": {
    "activeUntilDate": "有效期至：<Date>{{ date, textualWithTime }}</Date>",
    "canceledDate": "已取消：<Date>{{ date, textualWithTime }}</Date>",
    "command": {
      "actionButton": {
        "cancel": "取消",
        "execute": "执行",
        "queue": "排队"
      },
      "dates": {
        "activeAt": "待定至 {{date, }}",
        "executableAt": "可执行于 {{date, }}",
        "previousStep": "{{date, }}",
        "queueableAt": "可排队于 {{date, }}"
      },
      "description": {
        "bridged": "等待跨链桥传播交易",
        "canceled": "治理守护者已取消负载执行",
        "failed": "无法将负载发送到目标网络",
        "pending": "等待在 {{chainName}} 上执行负载",
        "pendingBsc": "等待投票开始",
        "waitingToBeExecutable": "等待排队期结束",
        "wrongChain": "该负载需在 {{chainName}} 链上执行"
      },
      "operations": {
        "title": "操作"
      },
      "status": {
        "pending": "待定"
      }
    },
    "commands": {
      "allPayloadsExecuted": "所有负载已执行",
      "somePayloadsExecuted": "已执行负载",
      "title": "命令"
    },
    "countdownFormat": {
      "daysIncluded": "{{days}}天 : {{hours}}小时 : {{minutes}}分 : {{seconds}}秒",
      "hoursIncluded": "{{hours}}小时 : {{minutes}}分 : {{seconds}}秒",
      "minutesIncluded": "{{minutes}}分 : {{seconds}}秒",
      "secondsIncluded": "{{seconds}}秒"
    },
    "defeatedDate": "已否决：<Date>{{ date, textualWithTime }}</Date>",
    "description": "描述",
    "executedDate": "已执行：<Date>{{ date, textualWithTime }}</Date>",
    "expiredDate": "已过期：<Date>{{ date, textualWithTime }}</Date>",
    "greenPulseAnimation": {
      "altText": "绿色脉冲动画"
    },
    "proposalState": {
      "activeTimestamp": "自 <Span>{{date, textualWithTime}}</Span> 起生效",
      "canceledTimestamp": "已取消：<Span>{{date, textualWithTime}}</Span>",
      "defeatedTimestamp": "已否决：<Span>{{date, textualWithTime}}</Span>",
      "executedTimestamp": "已执行：<Span>{{date, textualWithTime}}</Span>",
      "expiredTimestamp": "已过期：<Span>{{date, textualWithTime}}</Span>",
      "queuedTimestamp": "已排队：<Span>{{date, textualWithTime}}</Span>",
      "succeededTimestamp": "已成功：<Span>{{date, textualWithTime}}</Span>"
    },
    "queuedUntilDate": "排队至：<Date>{{ date, textualWithTime }}</Date>",
    "status": {
      "executedPayloads": "已执行负载",
      "readyForExecution": "准备执行",
      "readyForQueuing": "准备排队"
    },
    "statusCard": {
      "ariaLabelAbstain": "弃权票",
      "ariaLabelAgainst": "反对票",
      "ariaLabelFor": "赞成票"
    },
    "timeUntilExecutable": "可执行于：<Date>{{ date, textualWithTime }}</Date>",
    "timeUntilVotable": "投票开始：<Date>{{ date, textualWithTime }}</Date>",
    "voteStatus": {
      "abstained": "已弃权",
      "notVoted": "未投票",
      "votedAgainst": "已反对",
      "votedFor": "已赞成"
    },
    "votingOptions": "投票选项"
  },
  "voterDetail": {
    "actions": "操作",
    "amount": "数量",
    "delegated": "已委托",
    "delegatingTo": "委托给",
    "holding": "持有",
    "proposalNumber": "提案 #",
    "transactions": "交易",
    "undelegated": "未委托",
    "venusBalance": "Venus 余额",
    "viewAll": "查看全部",
    "votedAbstain": "已弃权",
    "votedAgainst": "已反对",
    "votedFor": "已赞成",
    "votes": "票数",
    "votingHistory": "投票历史"
  },
  "voterLeaderboard": {
    "addressesByVotingWeight": "按投票权重的地址",
    "columns": {
      "proposalsVoted": "已投票提案",
      "rank": "排名",
      "votes": "票数",
      "voteWeight": "投票权重"
    }
  },
  "voteSummary": {
    "addresses_zero": "{{count}} 个地址",
    "addresses_one": "{{count}} 个地址",
    "addresses_other": "{{count}} 个地址",
    "votes": "票数"
  },
  "wallets": {
    "errors": {
      "noProvider": "无法连接。请确保你选择的钱包已安装在浏览器中。"
    }
  },
  "web3DomainNames": {
    "providers": {
      "ens": "ENS 名称",
      "spaceId": "Space ID 名称"
    },
    "tooltip": {
      "address": "（{{address}}）"
    }
  }
}
